import { FormikProvider, useFormik, Form, Field, ErrorMessage, FieldArray } from "formik";
import React, { useEffect, useState } from "react";
import { Table, Row, Col } from "react-bootstrap";
import { config } from "../CommonUtils/CommonURLS";
import { CommonAxiosGet, CommonAxiosPost } from "../CommonUtils/CommonAxios";
import * as Yup from "yup";
import Swal from "sweetalert2";
import { failureAlert, successAlert2 } from "../CommonUtils/SweetAlerts";
import { VscDiffAdded } from "react-icons/vsc";
import { BiTrash } from "react-icons/bi";
import { shiftinggenerateDeficienciesPdf } from "../PdfGenerate";
import { ERROR_MSG } from "../CommonUtils/contextVariables";

// eslint-disable-next-line react/prop-types
export default function ScrutinyReportExtensionPermission({ collCode, nocType, instName }) {
  //generateDeficienciesPdf,
  //priyanka
  const [apiValues, setApiValues] = useState({});
  const [pgCourses, setPgCourses] = useState([]);
  const [corpusFundInstall, setCorpusFundInstall] = useState([]);
  const [isDisabled, setIsDisabled] = useState(false);
  const [getAccomidation, setAccom] = useState([])
  const [ugCorpusFunds, setUgCorpusFunds] = useState([]);
  const [pgCorpusFunds, setPgCorpusFunds] = useState([]);
  const [getPGBEFORE, setPGBEFORE] = useState([]);
  function getInspectionClosureDetails() {
    // collCode
    let url = config.url.FAC_URL + `getScrutinyDetails/${collCode}/${nocType}`;
    CommonAxiosGet(url)
      .then((res) => {
        if (res && res?.data?.status === true) {
          setApiValues(res?.data?.data?.[0] || {});
          setUgCourse(res?.data?.ugCourses || []);
          setPgCourses(Array.isArray(res?.data?.pgCourses) ? res.data.pgCourses : []);
          setCorpusFundInstall(Array.isArray(res?.data?.corpusFundInstall) ? res.data.corpusFundInstall : []);
          const buildArea = res.data.buildArea || [];
          const ugData = buildArea?.filter((item) => item?.build_block_name === "UG BLOCK");
          const pgData = buildArea?.filter((item) => item?.build_block_name === "PG BLOCK");
          const corpusData = res?.data?.corpusfundUGPG || [];
          const pgFunds = corpusData?.filter((item) => item.coll_type?.trim().toLowerCase().includes("pg"));
          const ug = corpusData?.filter((item) => item.coll_type?.trim().toLowerCase().includes("UG"));
          const PGBEFORE = corpusData?.filter((item) => item.coll_type?.trim().toLowerCase().includes("PG before"));
          const ugFunds = corpusData?.filter((item) => item.coll_type.replace(/"/g, "").trim() === "UG");
          const pgBeforeFunds = corpusData?.filter((item) => item.coll_type.replace(/"/g, "").trim() === "PG before");
          const pgAfterFunds = corpusData?.filter((item) => item.coll_type.replace(/"/g, "").trim() === "PG after");
          setUgCorpusFunds(ugFunds);
          setPGBEFORE(pgBeforeFunds);
          setPgCorpusFunds(pgAfterFunds);
        } else {
          setApiValues({});
        }
      });
  }

  const handleSave = async () => {
    const finalStatusSelected = formik.values.finalStatus && formik.values.finalStatus.trim() !== "";
    if (finalStatusSelected) {
      const errors = await formik.validateForm();
      // if (Object.keys(errors).length > 0) {
      //   Swal.fire({
      //     icon: "warning",
      //     title: "Cannot Save with Final Status",
      //     html: `You have selected a <strong>Final Status</strong> but some required fields are missing.<br/><br/>
      //            To save as a <strong>draft</strong>, please clear the Final Status selection.<br/>
      //            Or fill all required fields before saving with Final Status.`,
      //     confirmButtonColor: "#d33",
      //     confirmButtonText: "OK"
      //   });
      //   return;
      // }
    }
    submitInspClosureInst(formik.values, "save");
  };
  const [getUgCourses, setUgCourse] = useState([]);
  const getInstallmentData = (installmentNo) => {
    const installment = corpusFundInstall?.find((item) => item?.installment_no === installmentNo);
    return installment || {};
  };
  const validationSchema = Yup.object({
    //new

    // ========== REMARKS VALIDATIONS (all required) ==========
    // socityRegisteredRemarks: Yup.string().required(ERROR_MSG),--
    // byeLawsRemarks: Yup.string().required(ERROR_MSG),--
    // permissionOrderRemarks: Yup.string().required(ERROR_MSG),--
    // universityAffOrderRemarks: Yup.string().required(ERROR_MSG),--
    // collegeLocatedInRemarks: Yup.string().required(ERROR_MSG),..
    // lastEopRemarks: Yup.string().required(ERROR_MSG),--
    // landDeedProducedRemarks: Yup.string().required(ERROR_MSG),
    // landOwnedRemarks: Yup.string().required(ERROR_MSG),
    // buildingPlanApprovedRemarks: Yup.string().required(ERROR_MSG),
    // buildingPlanLicensedRemarks: Yup.string().required(ERROR_MSG),
    // buildingPlinthAreaRemarks: Yup.string().required(ERROR_MSG),
    // buildingConstructionPermissionRemarks: Yup.string().required(ERROR_MSG),
    // buildingSanitaryCertificateRemarks: Yup.string().required(ERROR_MSG),
    // buildingBuildingPhotographsRemarks: Yup.string().required(ERROR_MSG),
    // buildingMatchAnnexureRemarks: Yup.string().required(ERROR_MSG),
    // parkingPlaygroundRemarks: Yup.string().required(ERROR_MSG),
    // playgroundMoURemarks: Yup.string().when("alternativePlayground", {
    //   is: "Yes",
    //   then: (schema) => schema.required(ERROR_MSG),
    //   otherwise: (schema) => schema.notRequired()
    // }),
    // parkingExemptedCasesRemarks: Yup.string().required(ERROR_MSG),
    // corpusFundRemarks: Yup.string().required(ERROR_MSG),
    // certificateIssuedRemarks: Yup.string().when("corpusFund", {
    //   is: "Yes",
    //   then: (schema) => schema.required(ERROR_MSG),
    //   otherwise: (schema) => schema.notRequired(),
    // }),

    // infraLabEquipmentRemarks: Yup.string().required(ERROR_MSG),
    // infraLabLackEquipmentRemarks: Yup.string().when("infraLabEquipment", {
    //   is: "No",
    //   then: (schema) => schema.required(ERROR_MSG),
    //   otherwise: (schema) => schema.notRequired(),
    // }),
    // infraLibraryBooksProvidedRemarks: Yup.string().when("infraLibraryBooksProvided", {
    //   is: "No",
    //   then: (schema) => schema.required(ERROR_MSG),
    //   otherwise: (schema) => schema.notRequired(),
    // }),
    // infraLibraryLackBooksRemarks: Yup.string().required(ERROR_MSG),
    // infraStaffRunClgRemarks: Yup.string().required(ERROR_MSG),
    // infraStaffDeficienciesRemarks: Yup.string().when("infraStaffRunClg", {
    //   is: "No",
    //   then: (schema) => schema.required(ERROR_MSG),
    //   otherwise: (schema) => schema.notRequired(),
    // }),
    // infraStaffScholarshipDetailsRemarks: Yup.string().required(ERROR_MSG),
    // infraStaffUniversityRanksRemarks: Yup.string().required(ERROR_MSG),
    // infraStaffConductedExtensionRemarks: Yup.string().required(ERROR_MSG),
    // infraStaffFunctionalWebsiteRemarks: Yup.string().required(ERROR_MSG),
    // finalRemarksRemarks: Yup.string().required(ERROR_MSG),-----
    // finalStatusRemarks: Yup.string().required(ERROR_MSG),-----
    // sketchPlanProducedRemarks: Yup.string().required(ERROR_MSG),
    // scheduledPropertyRemarks: Yup.string().required(ERROR_MSG),
    // landOwnedAsPerNormsRemarks: Yup.string().required(ERROR_MSG),
    // landSameMandalRemarks: Yup.string().required(ERROR_MSG),
    // leaseDeedProducedRemarks: Yup.string().required(ERROR_MSG),--
    // validOrExpiredRemarks: Yup.string().required(ERROR_MSG),
    // runningInstitutionSameBuildingRemarks: Yup.string().required(ERROR_MSG),
    // parkingAvailableRemarks: Yup.string().when("parkingAvailable", {
    //   is: "No",
    //   then: (schema) => schema.required(ERROR_MSG),
    //   otherwise: (schema) => schema.notRequired()
    // }),
    // parkingArea20PercentRemarks: Yup.string().when("parkingAvailable", {
    //   is: "Yes",
    //   then: (schema) => schema.required(ERROR_MSG),
    //   otherwise: (schema) => schema.notRequired()
    // }),

    // parkingWithin100MetersRemarks: Yup.string().when("parkingAvailable", {
    //   is: "No",
    //   then: (schema) => schema.required(ERROR_MSG),
    //   otherwise: (schema) => schema.notRequired()
    // }),
    // playgroundAvailableRemarks: Yup.string().required(ERROR_MSG),
    // playgroundExtentRemarks: Yup.string().when("playgroundAvailable", {
    //   is: "Yes",
    //   then: (schema) => schema.required(ERROR_MSG),
    //   otherwise: (schema) => schema.notRequired()
    // }),
    // alternativePlaygroundRemarks: Yup.string().when("playgroundAvailable", {
    //   is: "No",
    //   then: (schema) => schema.required(ERROR_MSG),
    //   otherwise: (schema) => schema.notRequired()
    // }),
    // latestAffidavitRemarks: Yup.string().required(ERROR_MSG),
    // processingFeeRemarks: Yup.string().required(ERROR_MSG),
    // establishmentRemarks: Yup.string().required(ERROR_MSG),
    // affiliationOrder202526Remarks: Yup.string().required(ERROR_MSG),
    // societyRemarks: Yup.string().required(ERROR_MSG),
    // landRemarks: Yup.string().required(ERROR_MSG),
    // buildingRemarks: Yup.string().required(ERROR_MSG),
    // sanitaryRemarks: Yup.string().required(ERROR_MSG),
    // parkingRemarks: Yup.string().required(ERROR_MSG),
    // playgroundRemarks: Yup.string().required(ERROR_MSG),
    // fireSafetyRemarks: Yup.string().required(ERROR_MSG),
    // corpusFundExtraRemarks: Yup.string().required(ERROR_MSG),
    // otherDeficienciesRemarks: Yup.string().required(ERROR_MSG),
    // leaseToDateRemarks: Yup.string().required(ERROR_MSG),
    // leaseFromDateRemarks: Yup.string().required(ERROR_MSG),
    // totalYearsRemarks: Yup.string().required(ERROR_MSG),
    // nocProducedRemarks: Yup.string().when("runningInstitutionSameBuilding", {
    //   is: "Yes",
    //   then: (schema) => schema.required(ERROR_MSG),
    //   otherwise: (schema) => schema.notRequired(),
    // }),
    // parkingAreaDocUploadedRemarks: Yup.string().when("parkingWithin100Meters", {
    //   is: "Yes",
    //   then: (schema) => schema.required("Required"),
    //   otherwise: (schema) => schema.notRequired(),
    // }),
    //old
    socityRegistered: Yup.string().required(ERROR_MSG),
    byeLaws: Yup.string().required(ERROR_MSG),
    permissionOrder: Yup.string().required(ERROR_MSG),
    universityAffOrder: Yup.string().required(ERROR_MSG),
    lastEop: Yup.string().required(ERROR_MSG),
    landOwned: Yup.string().required(ERROR_MSG),
    landDeedProduced: Yup.string().required(ERROR_MSG),
    buildingPlanApproved: Yup.string().required(ERROR_MSG),
    buildingPlanLicensed: Yup.string().required(ERROR_MSG),
    buildingConstructionPermission: Yup.string().required(ERROR_MSG),
    buildingSanitaryCertificate: Yup.string().required(ERROR_MSG),
    buildingBuildingPhotographs: Yup.string().required(ERROR_MSG),
    buildingMatchAnnexure: Yup.string().required(ERROR_MSG),
    corpusFund: Yup.string().required(ERROR_MSG),
    certificateIssued: Yup.string().when("corpusFund", {
      is: "Yes",
      then: (schema) => schema.required(ERROR_MSG),
      otherwise: (schema) => schema.notRequired(),
    }),
    infraLabEquipment: Yup.string().required(ERROR_MSG),
    infraLabLackEquipment: Yup.string().when("infraLabEquipment", {
      is: "No",
      then: (schema) => schema.required(ERROR_MSG),
      otherwise: (schema) => schema.notRequired(),
    }),
    infraLibraryBooksProvided: Yup.string().required(ERROR_MSG),
    infraLibraryLackBooks: Yup.string().when("infraLibraryBooksProvided", {
      is: "No",
      then: (schema) => schema.required(ERROR_MSG),
      otherwise: (schema) => schema.notRequired(),
    }),
    infraStaffRunClg: Yup.string().required(" required"),
    infraStaffDeficiencies: Yup.string().when("infraStaffRunClg", {
      is: "No",
      then: (schema) => schema.required(ERROR_MSG),
      otherwise: (schema) => schema.notRequired(),
    }),
    infraStaffScholarshipDetails: Yup.string().required(ERROR_MSG),
    infraStaffUniversityRanks: Yup.string().required(ERROR_MSG),
    infraStaffConductedExtension: Yup.string().required(ERROR_MSG),
    infraStaffFunctionalWebsite: Yup.string().required(ERROR_MSG),
    finalRemarks: Yup.string()
      .required(ERROR_MSG)
      .min(10, "Final remarks must be at least 10 characters")
      .max(500, "Final remarks cannot exceed 500 characters"),
    finalStatus: Yup.string().required(ERROR_MSG),
    buildingPlinthArea: Yup.string().required(ERROR_MSG),
    landOwnedAsPerNorms: Yup.string().required(ERROR_MSG),
    landSameMandal: Yup.string().required(ERROR_MSG),
    leaseDeedProduced: Yup.string().required(ERROR_MSG),
    deficiencies: Yup.array().when("finalStatus", {
      is: "DeficiencyIdentified",
      then: (schema) => schema
        .of(
          Yup.object().shape({
            remarks: Yup.string()
              .required(ERROR_MSG)
              .min(5, "Please enter at least 5 characters")
              .max(500, "Remarks cannot exceed 500 characters")
          })
        )
        .min(1, "At least one deficiency is required")
        .required("Deficiencies are required"),
      otherwise: (schema) => schema.notRequired(),
    }),
    parkingAvailable: Yup.string().required(ERROR_MSG),
    parkingWithin100Meters: Yup.string().when("parkingAvailable", {
      is: "No",
      then: (schema) => schema.required(ERROR_MSG),
      otherwise: (schema) => schema.notRequired()
    }),
    parkingAreaWithin100mDocUploaded: Yup.string().when("parkingWithin100Meters", {
      is: "Yes",
      then: (schema) => schema.required("Required"),
      otherwise: (schema) => schema.notRequired(),
    }),

    parkingArea20Percent: Yup.string().when("parkingAvailable", {
      is: "Yes",
      then: (schema) => schema.required(ERROR_MSG),
      otherwise: (schema) => schema.notRequired()
    }),
    // parkingArea20Percent: Yup.string().required(ERROR_MSG),
    playgroundAvailable: Yup.string().required(ERROR_MSG),
    playgroundExtent: Yup.string().when("playgroundAvailable", {
      is: "Yes",
      then: (schema) => schema.required(ERROR_MSG),
      otherwise: (schema) => schema.notRequired()
    }),
    alternativePlayground: Yup.string().when("playgroundAvailable", {
      is: "No",
      then: (schema) => schema.required(ERROR_MSG),
      otherwise: (schema) => schema.notRequired()
    }),
    playgroundMoU: Yup.string().when("alternativePlayground", {
      is: "Yes",
      then: (schema) => schema.required(ERROR_MSG),
      otherwise: (schema) => schema.notRequired()
    }),
    parkingExemptedCases: Yup.string().required(ERROR_MSG),
    latestAffidavit: Yup.string().required(ERROR_MSG),
    runningInstitutionSameBuilding: Yup.string().required(ERROR_MSG),
    nocProduced: Yup.string().when("runningInstitutionSameBuilding", {
      is: "Yes",
      then: (schema) => schema.required(ERROR_MSG),
      otherwise: (schema) => schema.notRequired(),
    }),
    validOrExpired: Yup.string().required(ERROR_MSG),
    sketchPlanProduced: Yup.string().required(ERROR_MSG),
    scheduledProperty: Yup.string().required(ERROR_MSG),
    accomodation: Yup.array()
      .of(
        Yup.object({
          sufficientAsPerNorms: Yup.string().required(ERROR_MSG),
          // remarks: Yup.string().required(ERROR_MSG)
        })
      )
      .when([], {
        is: (val) => val && val.length > 0,
        then: (schema) => schema.min(1, 'Required'),
        otherwise: (schema) => schema.notRequired()
      }),
    // totalYears: Yup.string().required(ERROR_MSG),
    leaseFromDate: Yup.date()
      .required(ERROR_MSG),
    leaseToDate: Yup.date()
      .required(ERROR_MSG)
  });

  useEffect(() => {
    handleAccomidations();
  }, []);
  useEffect(() => {
    if (getAccomidation.length > 0) {
      const initialAccomData = getAccomidation?.map((item) => ({
        sufficientAsPerNorms: '',
        remarks: '',
        particularName: item.particular_name || '',
        particularCode: item.particular_code || ""
      }));
      formik.setFieldValue('accomodation', initialAccomData);
      FinaldataAfterSubmitHandleAccomidations();
    }
  }, [getAccomidation]);
  function handleAccomidations() {
    let url = `${config.url.FAC_URL}getAccommodationAreaData/${collCode}`;
    CommonAxiosGet(url)
      .then((res) => {
        if (res && res.data.status === true) {
          setAccom(res.data.data || [])
        } else {
          setAccom([]);
        }
      })
      .catch((error) => {
        console.error("Error fetching accomidation details:", error);
        setAccom([]);
      });
  }
  function FinaldataAfterSubmitHandleAccomidations() {
    let url = `${config.url.FAC_URL}getUgAccomodationDetails/${collCode}`;
    CommonAxiosGet(url)
      .then((res) => {
        if (res && res.data.status === true) {
          const savedData = res.data.data || [];
          if (savedData.length > 0 && formik.values.accomodation?.length > 0) {
            const updatedAccomData = formik?.values?.accomodation?.map((item) => {
              const matchingData = savedData?.find(
                data => data?.particular_name === item?.particularName
              );
              return {
                ...item,
                sufficientAsPerNorms: matchingData?.sufficient_as_per_norms || item.sufficientAsPerNorms,
                remarks: matchingData?.remarks || item.remarks
              };
            });
            formik.setFieldValue('accomodation', updatedAccomData);
          }
        }
      })
      .catch((error) => {
        console.error("Error fetching accomidation details:", error);
      });
  }
  const formik = useFormik({
    initialValues: {
      socityRegistered: "",
      byeLaws: "",
      permissionOrder: "",
      universityAffOrder: "",
      lastEop: "",
      landOwned: "",
      landDeedProduced: "",
      buildingPlanApproved: "",
      buildingPlanLicensed: "",
      buildingConstructionPermission: "",
      buildingSanitaryCertificate: "",
      buildingBuildingPhotographs: "",
      buildingMatchAnnexure: "",
      corpusFund: "",
      certificateIssued: "",
      infraLabEquipment: "",
      infraLabLackEquipment: "",
      infraLibraryBooksProvided: "",
      infraLibraryLackBooks: "",
      infraStaffRunClg: "",
      infraStaffDeficiencies: "",
      infraStaffScholarshipDetails: "",
      infraStaffUniversityRanks: "",
      infraStaffConductedExtension: "",
      infraStaffFunctionalWebsite: "",
      finalRemarks: "",
      finalStatus: "",
      buildingPlinthArea: "",
      parkingPlayground: "",
      processingFee: "",
      establishment: "",
      affiliationOrder202526: "",
      society: "",
      land: "",
      building: "",
      sanitary: "",
      parking: "",
      playground: "",
      fireSafety: "",
      otherDeficiencies: "",
      corpusFundValue: "",
      sketchPlanProduced: "",
      scheduledProperty: "",
      landOwnedAsPerNorms: "",
      landSameMandal: "",
      leaseDeedProduced: "",
      deficiencies: [{ remarks: "" }],
      playgroundAvailable: "",
      parkingWithin100Meters: "",
      parkingAreaWithin100mDocUploaded: "",
      parkingArea20Percent: "",
      totalYears: "",
      parkingAvailable: "",
      runningInstitutionSameBuilding: "",
      playgroundExtent: "",
      alternativePlayground: "",
      playgroundMoU: "",
      parkingExemptedCases: "",
      latestAffidavit: "",
      leaseToDate: "",
      leaseFromDate: "",
      nocProduced: "",
      accomodation: [],
      //newly added for remarks
      socityRegisteredRemarks: "",
      byeLawsRemarks: "",
      permissionOrderRemarks: "",
      universityAffOrderRemarks: "",
      collegeLocatedInRemarks: "",
      lastEopRemarks: "",
      landDeedProducedRemarks: "",
      landOwnedRemarks: "",
      buildingPlanApprovedRemarks: "",
      buildingPlanLicensedRemarks: "",
      buildingPlinthAreaRemarks: "",
      buildingConstructionPermissionRemarks: "",
      buildingSanitaryCertificateRemarks: "",
      buildingBuildingPhotographsRemarks: "",
      buildingMatchAnnexureRemarks: "",
      parkingPlaygroundRemarks: "",
      parkingExemptedCasesRemarks: "",
      corpusFundRemarks: "",
      certificateIssuedRemarks: "",
      infraLabEquipmentRemarks: "",
      infraLabLackEquipmentRemarks: "",
      infraLibraryBooksProvidedRemarks: "",
      infraLibraryLackBooksRemarks: "",
      infraStaffRunClgRemarks: "",
      infraStaffDeficienciesRemarks: "",
      infraStaffScholarshipDetailsRemarks: "",
      infraStaffUniversityRanksRemarks: "",
      infraStaffConductedExtensionRemarks: "",
      infraStaffFunctionalWebsiteRemarks: "",
      finalRemarksRemarks: "",
      finalStatusRemarks: "",
      sketchPlanProducedRemarks: "",
      scheduledPropertyRemarks: "",
      landOwnedAsPerNormsRemarks: "",
      landSameMandalRemarks: "",
      leaseDeedProducedRemarks: "",
      validOrExpiredRemarks: "",
      runningInstitutionSameBuildingRemarks: "",
      parkingAvailableRemarks: "",
      parkingArea20PercentRemarks: "",
      parkingWithin100MetersRemarks: "",
      playgroundAvailableRemarks: "",
      playgroundExtentRemarks: "",
      alternativePlaygroundRemarks: "",
      latestAffidavitRemarks: "",
      processingFeeRemarks: "",
      establishmentRemarks: "",
      affiliationOrder202526Remarks: "",
      societyRemarks: "",
      landRemarks: "",
      buildingRemarks: "",
      sanitaryRemarks: "",
      parkingRemarks: "",
      playgroundRemarks: "",
      fireSafetyRemarks: "",
      corpusFundExtraRemarks: "",
      otherDeficienciesRemarks: "",
      leaseToDateRemarks: "",
      leaseFromDateRemarks: "",
      totalYearsRemarks: "",
      nocProducedRemarks: "",
      parkingAreaDocUploadedRemarks: "",
      playgroundMoURemarks: "",
      collegeLocatedIn: "",
      // parkingAreaDocUploadedRemarks:""
      // accomodation: getAccomidation.map((item) => ({
      //   sufficientAsPerNorms: '',
      //   remarks: '',
      //   particularName: item.particular_name || '',
      //   particularCode: item.particularCode || ""
      // }))
    },
    enableReinitialize: true,
    validationSchema: validationSchema,
    onSubmit: async (values) => {
      submitInspClosureInst(values)
    },
    validateOnChange: true,
    validateOnBlur: true,
    validateOnMount: true,
  });
  const firstInstallment = getInstallmentData(1);
  const secondInstallment = getInstallmentData(2);
  const thirdInstallment = getInstallmentData(3);



  function submitInspClosureInst(values, mode = "submit") {
    if (mode === "submit") {
      // Only check deficiencies if that status is selected
      if (values.finalStatus === "DeficiencyIdentified") {
        const hasMissingDeficiency =
          !values?.deficiencies ||
          values.deficiencies.length === 0 ||
          values.deficiencies.some(d => !d?.remarks || d.remarks.trim() === "");

        if (hasMissingDeficiency) {
          Swal.fire({
            icon: "warning",
            title: "Please fill all required fields"
          });
          return;
        }
      }
    }


    // ✅ STEP 2: CONFIRMATION POPUP
    Swal.fire({
      title: "Are you sure?",
      text:
        mode === "save"
          ? "Do you want to save the draft"
          : "Do you want to submit?",
      icon: "warning",
      showCancelButton: true,
      confirmButtonText:
        mode === "save" ? "Yes, Save Draft" : "Yes, Submit",
      cancelButtonText: "Cancel"
    }).then((result) => {

      if (!result.isConfirmed) return;

      // ✅ STEP 3: BUILD PAYLOAD
      // const payload = {
      //   socityRegisteredRemarks: values.socityRegisteredRemarks,
      //   byeLawsRemarks: values.byeLawsRemarks,
      //   permissionOrderRemarks: values.permissionOrderRemarks,
      //   universityAffOrderRemarks: values.universityAffOrderRemarks,
      //   collegeLocatedInRemarks: values.collegeLocatedInRemarks,
      //   lastEopRemarks: values.lastEopRemarks,
      //   landDeedProducedRemarks: values.landDeedProducedRemarks,
      //   landOwnedRemarks: values.landOwnedRemarks,
      //   buildingPlanApprovedRemarks: values.buildingPlanApprovedRemarks,
      //   buildingPlanLicensedRemarks: values.buildingPlanLicensedRemarks,
      //   buildingPlinthAreaRemarks: values.buildingPlinthAreaRemarks,
      //   buildingConstructionPermissionRemarks: values.buildingConstructionPermissionRemarks,
      //   buildingSanitaryCertificateRemarks: values.buildingSanitaryCertificateRemarks,
      //   buildingBuildingPhotographsRemarks: values.buildingBuildingPhotographsRemarks,
      //   buildingMatchAnnexureRemarks: values.buildingMatchAnnexureRemarks,
      //   parkingPlaygroundRemarks: values.parkingPlaygroundRemarks,
      //   parkingExemptedCasesRemarks: values.parkingExemptedCasesRemarks,
      //   corpusFundRemarks: values.corpusFundRemarks,
      //   certificateIssuedRemarks: values.certificateIssuedRemarks,
      //   infraLabEquipmentRemarks: values.infraLabEquipmentRemarks,
      //   infraLabLackEquipmentRemarks: values.infraLabLackEquipmentRemarks,
      //   infraLibraryBooksProvidedRemarks: values.infraLibraryBooksProvidedRemarks,
      //   infraLibraryLackBooksRemarks: values.infraLibraryLackBooksRemarks,
      //   infraStaffRunClgRemarks: values.infraStaffRunClgRemarks,
      //   infraStaffDeficienciesRemarks: values.infraStaffDeficienciesRemarks,
      //   infraStaffScholarshipDetailsRemarks: values.infraStaffScholarshipDetailsRemarks,
      //   infraStaffUniversityRanksRemarks: values.infraStaffUniversityRanksRemarks,
      //   infraStaffConductedExtensionRemarks: values.infraStaffConductedExtensionRemarks,
      //   infraStaffFunctionalWebsiteRemarks: values.infraStaffFunctionalWebsiteRemarks,
      //   finalRemarksRemarks: values.finalRemarksRemarks,
      //   finalStatusRemarks: values.finalStatusRemarks,

      //   collCode: parseInt(collCode, 10),

      //   socityRegistered: values.socityRegistered,
      //   byeLaws: values.byeLaws,
      //   permissionOrder: values.permissionOrder,
      //   universityAffOrder: values.universityAffOrder,

      //   collegeLocatedIn: apiValues.rural_area,

      //   lastEop: values.lastEop,
      //   landDeedProduced: values.landDeedProduced,
      //   landOwned: values.landOwned,

      //   buildingPlanApproved: values.buildingPlanApproved,
      //   buildingPlanLicensed: values.buildingPlanLicensed,
      //   buildingPlinthArea: values.buildingPlinthArea || "",

      //   buildingConstructionPermission: values.buildingConstructionPermission,
      //   buildingSanitaryCertificate: values.buildingSanitaryCertificate,
      //   buildingBuildingPhotographs: values.buildingBuildingPhotographs,
      //   buildingMatchAnnexure: values.buildingMatchAnnexure,

      //   parkingPlayground: values.parkingPlayground || "",
      //   parkingExemptedCases: values.parkingExemptedCases ? "Yes" : "No",

      //   corpusFund: values.corpusFund,
      //   certificateIssued: values.certificateIssued,

      //   infraLabEquipment: values.infraLabEquipment,
      //   infraLabLackEquipment: values.infraLabLackEquipment,
      //   infraLibraryBooksProvided: values.infraLibraryBooksProvided,
      //   infraLibraryLackBooks: values.infraLibraryLackBooks,

      //   infraStaffRunClg: values.infraStaffRunClg,
      //   infraStaffDeficiencies: values.infraStaffDeficiencies,
      //   infraStaffScholarshipDetails: values.infraStaffScholarshipDetails,
      //   infraStaffUniversityRanks: values.infraStaffUniversityRanks,
      //   infraStaffConductedExtension: values.infraStaffConductedExtension,
      //   infraStaffFunctionalWebsite: values.infraStaffFunctionalWebsite,

      //   finalRemarks: values.finalRemarks,
      //   finalStatus: values.finalStatus,

      //   processingFee: values.processingFee || "",
      //   establishment: values.establishment || "",
      //   affiliationOrder202526: values.affiliationOrder202526 || "",
      //   society: values.society || "",
      //   land: values.land || "",
      //   building: values.building || "",
      //   sanitary: values.sanitary || "",
      //   parking: values.parking || "",
      //   playground: values.playground || "",
      //   fireSafety: values.fireSafety || "",
      //   otherDeficiencies: values.otherDeficiencies || "",

      //   corpusFundValue: values.corpusFundValue || "",
      //   sketchPlanProduced: values.sketchPlanProduced || "",
      //   scheduledProperty: values.scheduledProperty || "",

      //   // ✅ FIXED: DO NOT HARD CODE
      //   nocType: values?.nocType,

      //   landOwnedAsPerNorms: values.landOwnedAsPerNorms || "",
      //   landSameMandal: values.landSameMandal || "",
      //   leaseDeedProduced: values.leaseDeedProduced || "",
      //   validOrExpired: values.validOrExpired || "",
      //   runningInstitutionSameBuilding: values.runningInstitutionSameBuilding || "",
      //   nocProduced: values.nocProduced || "",

      //   parkingAvailable: values.parkingAvailable || "",
      //   parkingArea20Percent: values.parkingArea20Percent || "",
      //   parkingWithin100Meters: values.parkingWithin100Meters || "",
      //   parkingAreaWithin100mDocUploaded: values.parkingAreaWithin100mDocUploaded || "",

      //   playgroundAvailable: values.playgroundAvailable || "",
      //   playgroundExtent: values.playgroundExtent || "",
      //   alternativePlayground: values.alternativePlayground || "",
      //   playgroundMoU: values.playgroundMoU || "",

      //   latestAffidavit: values.latestAffidavit || "",
      //   totalYears: values.totalYears || "",
      //   leaseToDate: values.leaseToDate || "",
      //   leaseFromDate: values.leaseFromDate || "",

      //   deficiencies: values.deficiencies || [],

      //   accomodation: values?.accomodation?.map((item) => ({
      //     sufficientAsPerNorms: item.sufficientAsPerNorms,
      //     remarks: item.remarks,
      //     particularName: item.particularName,
      //     particularCode: item.particularCode ? String(item.particularCode) : ""
      //   })) || []
      // };
      const payload = {
        //remarks
        socityRegisteredRemarks: values.socityRegisteredRemarks,
        byeLawsRemarks: values.byeLawsRemarks,
        permissionOrderRemarks: values.permissionOrderRemarks,
        universityAffOrderRemarks: values.universityAffOrderRemarks,
        collegeLocatedInRemarks: values.collegeLocatedInRemarks,
        lastEopRemarks: values.lastEopRemarks,
        landDeedProducedRemarks: values.landDeedProducedRemarks,
        landOwnedRemarks: values.landOwnedRemarks,
        buildingPlanApprovedRemarks: values.buildingPlanApprovedRemarks,
        buildingPlanLicensedRemarks: values.buildingPlanLicensedRemarks,
        buildingPlinthAreaRemarks: values.buildingPlinthAreaRemarks,
        buildingConstructionPermissionRemarks: values.buildingConstructionPermissionRemarks,
        buildingSanitaryCertificateRemarks: values.buildingSanitaryCertificateRemarks,
        buildingBuildingPhotographsRemarks: values.buildingBuildingPhotographsRemarks,
        buildingMatchAnnexureRemarks: values.buildingMatchAnnexureRemarks,
        parkingPlaygroundRemarks: values.parkingPlaygroundRemarks,
        parkingExemptedCasesRemarks: values.parkingExemptedCasesRemarks,
        corpusFundRemarks: values.corpusFundRemarks,
        certificateIssuedRemarks: values.certificateIssuedRemarks,
        infraLabEquipmentRemarks: values.infraLabEquipmentRemarks,
        infraLabLackEquipmentRemarks: values.infraLabLackEquipmentRemarks,
        infraLibraryBooksProvidedRemarks: values.infraLibraryBooksProvidedRemarks,
        infraLibraryLackBooksRemarks: values.infraLibraryLackBooksRemarks,
        infraStaffRunClgRemarks: values.infraStaffRunClgRemarks,
        infraStaffDeficienciesRemarks: values.infraStaffDeficienciesRemarks,
        infraStaffScholarshipDetailsRemarks: values.infraStaffScholarshipDetailsRemarks,
        infraStaffUniversityRanksRemarks: values.infraStaffUniversityRanksRemarks,
        infraStaffConductedExtensionRemarks: values.infraStaffConductedExtensionRemarks,
        infraStaffFunctionalWebsiteRemarks: values.infraStaffFunctionalWebsiteRemarks,
        finalRemarksRemarks: values.finalRemarksRemarks,
        finalStatusRemarks: values.finalStatusRemarks,
        sketchPlanProducedRemarks: values.sketchPlanProducedRemarks,
        scheduledPropertyRemarks: values.scheduledPropertyRemarks,
        landOwnedAsPerNormsRemarks: values.landOwnedAsPerNormsRemarks,
        landSameMandalRemarks: values.landSameMandalRemarks,
        leaseDeedProducedRemarks: values.leaseDeedProducedRemarks,
        validOrExpiredRemarks: values.validOrExpiredRemarks,
        runningInstitutionSameBuildingRemarks: values.runningInstitutionSameBuildingRemarks,
        parkingAvailableRemarks: values.parkingAvailableRemarks,
        parkingArea20PercentRemarks: values.parkingArea20PercentRemarks,
        parkingWithin100MetersRemarks: values.parkingWithin100MetersRemarks,
        playgroundAvailableRemarks: values.playgroundAvailableRemarks,
        playgroundExtentRemarks: values.playgroundExtentRemarks,
        alternativePlaygroundRemarks: values.alternativePlaygroundRemarks,
        latestAffidavitRemarks: values.latestAffidavitRemarks,
        processingFeeRemarks: values.processingFeeRemarks,
        establishmentRemarks: values.establishmentRemarks,
        affiliationOrder202526Remarks: values.affiliationOrder202526Remarks,
        societyRemarks: values.societyRemarks,
        landRemarks: values.landRemarks,
        buildingRemarks: values.buildingRemarks,
        sanitaryRemarks: values.sanitaryRemarks,
        parkingRemarks: values.parkingRemarks,
        playgroundRemarks: values.playgroundRemarks,
        fireSafetyRemarks: values.fireSafetyRemarks,
        corpusFundExtraRemarks: values.corpusFundExtraRemarks,
        otherDeficienciesRemarks: values.otherDeficienciesRemarks,
        leaseToDateRemarks: values.leaseToDateRemarks,
        leaseFromDateRemarks: values.leaseFromDateRemarks,
        totalYearsRemarks: values.totalYearsRemarks,
        nocProducedRemarks: values.nocProducedRemarks,
        parkingAreaDocUploadedRemarks: values.parkingAreaDocUploadedRemarks,
        playgroundMoURemarks: values.playgroundMoURemarks,
        isSubmitted: mode === "submit" ? true : false,
        //old
        // collCode: collCode,
        collCode: parseInt(collCode, 10),
        socityRegistered: values.socityRegistered,
        byeLaws: values.byeLaws,
        permissionOrder: values.permissionOrder,
        universityAffOrder: values.universityAffOrder,
        collegeLocatedIn: corpusFundInstall[0]?.rural_area || "-",
        lastEop: values.lastEop,
        landDeedProduced: values.landDeedProduced,
        landOwned: values.landOwned,
        buildingPlanApproved: values.buildingPlanApproved,
        buildingPlanLicensed: values.buildingPlanLicensed,
        buildingPlinthArea: values.buildingPlinthArea || "",
        buildingConstructionPermission: values.buildingConstructionPermission,
        buildingSanitaryCertificate: values.buildingSanitaryCertificate,
        buildingBuildingPhotographs: values.buildingBuildingPhotographs,
        buildingMatchAnnexure: values.buildingMatchAnnexure,
        parkingPlayground: values.parkingPlayground || "",
        parkingExemptedCases: values.parkingExemptedCases ? "Yes" : "No",
        corpusFund: values.corpusFund,
        certificateIssued: values.certificateIssued,
        infraLabEquipment: values.infraLabEquipment,
        infraLabLackEquipment: values.infraLabLackEquipment,
        infraLibraryBooksProvided: values.infraLibraryBooksProvided,
        infraLibraryLackBooks: values.infraLibraryLackBooks,
        infraStaffRunClg: values.infraStaffRunClg,
        infraStaffDeficiencies: values.infraStaffDeficiencies,
        infraStaffScholarshipDetails: values.infraStaffScholarshipDetails,
        infraStaffUniversityRanks: values.infraStaffUniversityRanks,
        infraStaffConductedExtension: values.infraStaffConductedExtension,
        infraStaffFunctionalWebsite: values.infraStaffFunctionalWebsite,
        finalRemarks: values.finalRemarks,
        finalStatus: values.finalStatus,
        processingFee: values.processingFee || "",
        establishment: values.establishment || "",
        affiliationOrder202526: values.affiliationOrder202526 || "",
        society: values.society || "",
        land: values.land || "",
        building: values.building || "",
        sanitary: values.sanitary || "",
        parking: values.parking || "",
        playground: values.playground || "",
        fireSafety: values.fireSafety || "",
        otherDeficiencies: values.otherDeficiencies || "",
        corpusFundValue: values.corpusFundValue || "",
        sketchPlanProduced: values.sketchPlanProduced || "",
        scheduledProperty: values.scheduledProperty || "",
        nocType: "eop",
        landOwnedAsPerNorms: values.landOwnedAsPerNorms || "",
        landSameMandal: values.landSameMandal || "",
        leaseDeedProduced: values.leaseDeedProduced || "",
        validOrExpired: values.validOrExpired || "",
        runningInstitutionSameBuilding: values.runningInstitutionSameBuilding || "",
        nocProduced: values.nocProduced || "",
        parkingAvailable: values.parkingAvailable || "",
        parkingArea20Percent: values.parkingArea20Percent || "",
        parkingWithin100Meters: values.parkingWithin100Meters || "",
        parkingAreaWithin100mDocUploaded: values.parkingAreaWithin100mDocUploaded || "",
        playgroundAvailable: values.playgroundAvailable || "",
        playgroundExtent: values.playgroundExtent || "",
        alternativePlayground: values.alternativePlayground || "",
        playgroundMoU: values.playgroundMoU || "",
        latestAffidavit: values.latestAffidavit || "",
        totalYears: values.totalYears || "",
        leaseToDate: values.leaseToDate || "",
        leaseFromDate: values.leaseFromDate || "",
        deficiencies: values.deficiencies || [],
        // accomodation: values.accomodation || []
        accomodation: values?.accomodation?.map((item) => ({
          sufficientAsPerNorms: item.sufficientAsPerNorms,
          remarks: item.remarks,
          particularName: item.particularName,
          particularCode: item.particularCode ? String(item.particularCode) : ""
        })) || []


      };
      // ✅ STEP 4: API CALL
      let url = config.url.FAC_URL + "saveEOPScrutinyDetails";

      CommonAxiosPost(url, payload)
        .then((res) => {

          if (res.data.status === true) {

            if (res.data.scode === "01") {
              successAlert2(
                mode === "save"
                  ? "Saved Successfully!"
                  : res.data.sdesc
              );

              window.location.reload();

            } else {
              failureAlert(res.data.sdesc);
            }

          } else {
            failureAlert(res.data.sdesc);
          }

        })
        .catch((e) => {
          console.error(e);
          failureAlert(res.data.sdesc)
        });

    });
  }
  useEffect(() => {
    if (getAccomidation?.length > 0) {
      const initialAccomData = getAccomidation?.map((item) => ({
        sufficientAsPerNorms: '',
        remarks: '',
        particularName: item.particular_name || '',
        particularCode: item.particular_code || ""
      }));
      formik.setFieldValue('accomodation', initialAccomData);
      FinaldataAfterSubmitHandleAccomidations();
    }
  }, [getAccomidation]);
  const handleDownloadPDF = () => {
    let url = `${config.url.FAC_URL}getEOPDeficiencyDetails/${collCode}`;
    CommonAxiosGet(url)
      .then((res) => {
        if (res && res.data.status === true) {
          const deficiencyData = res.data.data || [];
          if (deficiencyData.length > 0) {
            const rowData = {
              inst_name: apiValues.inst_name || apiValues.society_name || "College",
              coll_code: collCode,
              noc_type: "Eop",
              def: deficiencyData?.map((iteswm) => ({
                remarks: item.remarks || "No remarks provided"
              }))
            };
            shiftinggenerateDeficienciesPdf(rowData);
          }
        }
      })
      .catch((error) => {
        console.error("Error:", error);
      });
  };
  const [getDef, setDef] = useState([])
  function handleAddDeficiency() {
    let url = `${config.url.FAC_URL}getEOPDeficiencyDetails/${collCode}`;
    CommonAxiosGet(url)
      .then((res) => {
        if (res && res.data.status === true) {
          const deficiencyData = res.data.data || [];
          setDef(res.data.data || []);

          if (deficiencyData.length > 0) {

            const mappedDeficiencies = deficiencyData?.map((item) => ({
              remarks:
                item.deficiency_description ||
                item.remarks ||
                item.deficiency ||
                "-"
            }));

            formik.setFieldValue('deficiencies', mappedDeficiencies);

          } else {
            formik.setFieldValue('deficiencies', [{ remarks: "" }]);
          }
        } else {
        }
      })
      .catch((error) => {
        console.error("Error fetching deficiencies:", error);
      });
  }
  useEffect(() => {
    const loadData = async () => {
      await getInspectionClosureDetails();
      await finalGetAfterSubmit();  // Load main data first
      await handleAccomidations();
      await FinaldataAfterSubmitHandleAccomidations();
    };
    loadData();
  }, []);
  useEffect(() => {
    if (formik.values.finalStatus === "DeficiencyIdentified") {
      handleAddDeficiency();
    }
  }, [formik.values.finalStatus]);
  const [finalGet, setFinalGet] = useState([])
  function finalGetAfterSubmit() {
    let url = `${config.url.FAC_URL}getEOPScrutinyDetails/${collCode}`;
    CommonAxiosGet(url)
      .then((res) => {
        const data = res?.data?.data;

        if (data && data.length > 0) {
          const d = data[0];
          // if (d) {
          //   if (d.final_status === "NoDeficienciesIdentified" || d.final_status === "DeficiencyIdentified") {
          //     setIsDisabled(true);

          //   } else {
          //     setIsDisabled(false);
          //   }
          // }

          if (d) {
            setIsDisabled(d.is_submitted);
          }
          setFinalGet(data);
          const mappedValues = {
            socityRegistered: d.socity_registered || "",
            byeLaws: d.bye_laws || "",
            permissionOrder: d.permission_order || "",
            universityAffOrder: d.university_aff_order || "",
            lastEop: d.last_eop || "",
            landDeedProduced: d.land_deed_produced || "",
            landOwned: d.land_owned || "",
            buildingPlanApproved: d.building_plan_approved || "",
            buildingPlanLicensed: d.building_plan_licensed || "",
            buildingPlinthArea: d.building_plinth_area || "",
            buildingConstructionPermission: d.building_construction_permission || "",
            buildingSanitaryCertificate: d.building_sanitary_certificate || "",
            buildingBuildingPhotographs: d.building_building_photographs || "",
            buildingMatchAnnexure: d.building_match_annexure || "",
            // parkingPlayground: d.parking_playground || "",
            parkingExemptedCases: d.parking_exempted_cases || "",
            corpusFund: d.corpus_fund || "",
            certificateIssued: d.certificate_issued || "",
            infraLabEquipment: d.infra_lab_equipment || "",
            infraLabLackEquipment: d.infra_lab_lack_equipment || "",
            infraLibraryBooksProvided: d.infra_library_books_provided || "",
            infraLibraryLackBooks: d.infra_library_lack_books || "",
            infraStaffRunClg: d.infra_staff_run_clg || "",
            infraStaffDeficiencies: d.infra_staff_deficiencies || "",
            infraStaffScholarshipDetails: d.infra_staff_scholarship_details || "",
            infraStaffUniversityRanks: d.infra_staff_university_ranks || "",
            infraStaffConductedExtension: d.infra_staff_conducted_extension || "",
            infraStaffFunctionalWebsite: d.infra_staff_functional_website || "",
            finalRemarks: d.final_remarks || "",
            finalStatus: d.final_status || "",
            processingFee: d.processing_fee || "",
            establishment: d.establishment || "",
            affiliationOrder202526: d.affiliation_order_2025_26 || "",
            society: d.society || "",
            land: d.land || "",
            building: d.building || "",
            sanitary: d.sanitary || "",
            parking: d.parking || "",
            playground: d.playground || "",
            fireSafety: d.fire_safety || "",
            otherDeficiencies: d.other_deficiencies || "",
            corpusFundValue: d.corpus_fund_value || "",
            scheduledProperty: d.scheduled_property || "",
            sketchPlanProduced: d.sketch_plan_produced || "",
            deficiencies: d.deficiencies || [{ remarks: "" }],
            leaseFromDate: d.lease_from_date || "",
            leaseToDate: d.lease_to_date || "",
            // totalYears: d.total_years || "",
            nocProduced: d.noc_produced || "",
            playgroundMoU: d.playground_mou || "",
            validOrExpired: d.valid_or_expired || "",
            latestAffidavit: d.latest_affidavit || "",
            // 7. Alternative Playground
            alternativePlayground: d.alternative_playground || "",
            // 8. Parking Playground (you have this but check if mapping)
            parkingPlayground: d.parking_playground || "",
            landOwnedAsPerNorms: d.land_owned_as_per_norms || "",
            landSameMandal: d.land_same_mandal || "",
            leaseDeedProduced: d.lease_deed_produced || "",
            totalYears: d.total_years || "",
            runningInstitutionSameBuilding: d.running_institution_same_building || "",
            playgroundAvailable: d.playground_available || "",
            playgroundExtent: d.playground_extent || "",
            parkingAvailable: d.parking_available || "",
            parkingWithin100Meters: d.parking_within_100_meters || "",
            parkingAreaWithin100mDocUploaded: d.parking_area_doc_uploaded || d.parking_area_within_100m_doc_uploaded || "",
            parkingArea20Percent: d.parking_area_20_percent || "",
            //remarks
            // Remarks mapping
            socityRegisteredRemarks: d.socity_registered_remarks || "",
            byeLawsRemarks: d.bye_laws_remarks || "",
            permissionOrderRemarks: d.permission_order_remarks || "",
            universityAffOrderRemarks: d.university_aff_order_remarks || "",
            collegeLocatedInRemarks: d.college_located_in_remarks || "",
            lastEopRemarks: d.last_eop_remarks || "",
            landDeedProducedRemarks: d.land_deed_produced_remarks || "",
            landOwnedRemarks: d.land_owned_remarks || "",
            buildingPlanApprovedRemarks: d.building_plan_approved_remarks || "",
            buildingPlanLicensedRemarks: d.building_plan_licensed_remarks || "",
            buildingPlinthAreaRemarks: d.building_plinth_area_remarks || "",
            buildingConstructionPermissionRemarks: d.building_construction_permission_remarks || "",
            buildingSanitaryCertificateRemarks: d.building_sanitary_certificate_remarks || "",
            buildingBuildingPhotographsRemarks: d.building_building_photographs_remarks || "",
            buildingMatchAnnexureRemarks: d.building_match_annexure_remarks || "",
            parkingPlaygroundRemarks: d.parking_playground_remarks || "",
            parkingExemptedCasesRemarks: d.parking_exempted_cases_remarks || "",
            corpusFundRemarks: d.corpus_fund_remarks || "",
            certificateIssuedRemarks: d.certificate_issued_remarks || "",
            infraLabEquipmentRemarks: d.infra_lab_equipment_remarks || "",
            infraLabLackEquipmentRemarks: d.infra_lab_lack_equipment_remarks || "",
            infraLibraryBooksProvidedRemarks: d.infra_library_books_provided_remarks || "",
            infraLibraryLackBooksRemarks: d.infra_library_lack_books_remarks || "",
            infraStaffRunClgRemarks: d.infra_staff_run_clg_remarks || "",
            infraStaffDeficienciesRemarks: d.infra_staff_deficiencies_remarks || "",
            infraStaffScholarshipDetailsRemarks: d.infra_staff_scholarship_details_remarks || "",
            infraStaffUniversityRanksRemarks: d.infra_staff_university_ranks_remarks || "",
            infraStaffConductedExtensionRemarks: d.infra_staff_conducted_extension_remarks || "",
            infraStaffFunctionalWebsiteRemarks: d.infra_staff_functional_website_remarks || "",
            finalRemarksRemarks: "", // no separate column? maybe final_remarks_remarks? Not in SQL. Skip or add if exists.
            finalStatusRemarks: "", // skip as not in SQL
            sketchPlanProducedRemarks: d.sketch_plan_produced_remarks || "",
            scheduledPropertyRemarks: d.scheduled_property_remarks || "",
            landOwnedAsPerNormsRemarks: d.land_owned_as_per_norms_remarks || "",
            landSameMandalRemarks: d.land_same_mandal_remarks || "",
            leaseDeedProducedRemarks: d.lease_deed_produced_remarks || "",
            validOrExpiredRemarks: d.valid_or_expired_remarks || "",
            runningInstitutionSameBuildingRemarks: d.running_institution_same_building_remarks || "",
            parkingAvailableRemarks: d.parking_available_remarks || "",
            parkingArea20PercentRemarks: d.parking_area_20_percent_remarks || "",
            parkingWithin100MetersRemarks: d.parking_within_100_meters_remarks || "",
            playgroundAvailableRemarks: d.playground_available_remarks || "",
            playgroundExtentRemarks: d.playground_extent_remarks || "",
            alternativePlaygroundRemarks: d.alternative_playground_remarks || "",
            latestAffidavitRemarks: d.latest_affidavit_remarks || "",
            processingFeeRemarks: d.processing_fee_remarks || "",
            establishmentRemarks: d.establishment_remarks || "",
            affiliationOrder202526Remarks: d.affiliation_order_2025_26_remarks || "",
            societyRemarks: d.society_remarks || "",
            landRemarks: d.land_remarks || "",
            buildingRemarks: d.building_remarks || "",
            sanitaryRemarks: d.sanitary_remarks || "",
            parkingRemarks: d.parking_remarks || "",
            playgroundRemarks: d.playground_remarks || "",
            fireSafetyRemarks: d.fire_safety_remarks || "",
            corpusFundExtraRemarks: d.corpus_fund_extra_remarks || "",
            otherDeficienciesRemarks: d.other_deficiencies_remarks || "",
            leaseToDateRemarks: d.lease_to_date_remarks || "",
            leaseFromDateRemarks: d.lease_from_date_remarks || "",
            totalYearsRemarks: d.total_years_remarks || "",
            nocProducedRemarks: d.noc_produced_remarks || "",
            parkingAreaDocUploadedRemarks: d.parking_area_doc_uploaded_remarks || "",
            playgroundMoURemarks: d.playground_mou_remarks || "",
          };

          formik.setValues(mappedValues);

        } else {
          setFinalGet([]);
        }
      })
      .catch((error) => {
        console.error("Error fetching scrutiny details:", error);
        setFinalGet([]);;
      });
  }

  const clearDependentFields = (fieldName, value) => {
    switch (fieldName) {
      case "parkingAvailable":
        if (value === "Yes") {
          formik.setFieldValue("parkingWithin100Meters", "");
          formik.setFieldValue("parkingAreaWithin100mDocUploaded", "");
        }
        if (value === "No") {
          formik.setFieldValue("parkingArea20Percent", "");
        }
        break;

      case "parkingWithin100Meters":
        if (value === "No") {
          formik.setFieldValue("parkingAreaWithin100mDocUploaded", "");
        }
        break;

      case "playgroundAvailable":
        if (value === "Yes") {
          formik.setFieldValue("alternativePlayground", "");
          formik.setFieldValue("playgroundMoU", "");
        }
        if (value === "No") {
          formik.setFieldValue("playgroundExtent", "");
        }
        break;

      case "alternativePlayground":
        if (value !== "Yes") {
          formik.setFieldValue("playgroundMoU", "");
        }
        break;

      case "corpusFund":
        if (value !== "Yes") {
          formik.setFieldValue("certificateIssued", "");
        }
        break;

      case "infraLabEquipment":
        if (value !== "No") {
          formik.setFieldValue("infraLabLackEquipment", "");
        }
        break;

      case "infraLibraryBooksProvided":
        if (value !== "No") {
          formik.setFieldValue("infraLibraryLackBooks", "");
        }
        break;

      case "infraStaffRunClg":
        if (value !== "No") {
          formik.setFieldValue("infraStaffDeficiencies", "");
        }
        break;

      case "runningInstitutionSameBuilding":
        if (value !== "Yes") {
          formik.setFieldValue("nocProduced", "");
        }
        break;

      case "finalStatus":
        if (value !== "DeficiencyIdentified") {
          formik.setFieldValue("deficiencies", [{ remarks: "" }]);
        }
        break;

      default:
        break;
    }
  };
  console.log("Formik Errors:", formik.errors);
  const textareaStyle = {
    height: "auto",
    resize: "vertical",
  };
  useEffect(() => {
    const style = document.createElement("style");

    style.innerHTML = `
        textarea.form-control {
            height: auto;
            resize: vertical;
        }
    `;

    document.head.appendChild(style);

    return () => {
      document.head.removeChild(style);
    };
  }, []);
  const handleFinalSubmit = async (mode = "submit") => {
    const errors = await formik.validateForm();

    const hasErrors = Object.keys(errors).length > 0;

    if (mode === "submit" && hasErrors) {

      Swal.fire({
        icon: "warning",
        title: "Please fill all required fields"
      });

      return;
    }

    submitInspClosureInst(formik.values, mode);
  };


  return (
    <FormikProvider value={formik}>
      <Form onSubmit={formik.handleSubmit} >
        <h5 className="text-success mb-3">
          {instName || '-'} - Scrutiny Report for Extension of Permission (EoP)
        </h5>        <Row className="mb-3">
          {/* Column 1 */}
          <Col md={6}>
            <label className="form-label fw-bold">Name of the Society & Address</label>
            <textarea
              name="societyDetails"
              className="form-control"
              rows="3"
              value={apiValues.society_name
                || "-"
              }
              onChange={formik.handleChange}
              onBlur={formik.handleBlur}
              placeholder="Enter society name and address"
            />
          </Col>

          {/* Column 2 */}
          <Col md={6}>
            <label className="form-label fw-bold">Name and Address of the Institute</label>
            <textarea
              name="collegeDetails"
              className="form-control"
              rows="3"
              value={apiValues?.inst_name || apiValues?.mandal_name || "-"}
              onChange={formik.handleChange}
              onBlur={formik.handleBlur}
              placeholder="Enter college name and address"
            />
          </Col>
        </Row>
        <Row>
          <Col>
            <Table bordered responsive>
              <thead className="table-primary text-center">
                <tr>
                  <th style={{ width: "8%" }}>S.No</th>
                  <th style={{ width: "42%" }}>Particulars</th>
                  <th style={{ width: "20%" }}>Action</th>
                  <th style={{ width: "20%" }}>Remarks</th>
                </tr>
              </thead>
              <tbody>
                <tr>
                  <td className="text-center">1</td>
                  <td>Transaction Id of Registration and processing fee paid (Rs 30,000)</td>
                  <td>{apiValues.transaction_id || "-"}</td>
                  <td>-</td>

                </tr>

                <tr>
                  <td className="text-center">2</td>
                  <td>Whether the Society is registered under societies registration act</td>
                  <td>
                    <input type="radio" name="socityRegistered" value="Yes" checked={formik.values.socityRegistered === "Yes"} onChange={formik.handleChange} disabled={isDisabled} /> Yes &nbsp;
                    <input type="radio" name="socityRegistered" value="No" checked={formik.values.socityRegistered === "No"} onChange={formik.handleChange} disabled={isDisabled} /> No
                    <ErrorMessage name="socityRegistered" component="div" className="text-danger" />
                  </td>
                  <td>
                    <Field
                      as="textarea"
                      name="socityRegisteredRemarks"
                      className="form-control"
                      placeholder="Remarks"
                      rows="3"
                      disabled={isDisabled}
                      style={textareaStyle}
                    />
                    {/* <ErrorMessage name="socityRegisteredRemarks" component="div" className="text-danger" /> */}
                  </td>
                </tr>
                <tr>
                  <td className="text-center">3</td>
                  <td>Whether the Bye-laws of the Society is enclosed</td>
                  <td>
                    {/* name="permissionOrder" value="Yes" checked={formik.values.permissionOrder === "Yes"} onChange={formik.handleChange} */}
                    <input type="radio" value="Yes" name="byeLaws" checked={formik.values.byeLaws === "Yes"} onChange={formik.handleChange} disabled={isDisabled} /> Yes &nbsp;
                    <input type="radio" value="No" name="byeLaws" checked={formik.values.byeLaws === "No"} onChange={formik.handleChange} disabled={isDisabled} /> No
                    <ErrorMessage name="byeLaws" component="div" className="text-danger" />

                  </td>
                  <td>
                    <Field
                      as="textarea"
                      name="byeLawsRemarks"
                      className="form-control"
                      placeholder="Remarks"
                      rows="3"
                      disabled={isDisabled}
                      style={textareaStyle}
                    />
                    {/* <ErrorMessage name="byeLawsRemarks" component="div" className="text-danger" /> */}
                  </td>
                </tr>
                <tr>
                  <td className="text-center">4</td>
                  <td>Year of Establishment of the College</td>
                  <td>{apiValues.year_of_establishment || "-"}</td>
                  <td>-</td>
                </tr>
                <tr>
                  <td className="text-center">5</td>
                  <td>Whether the permission order for the establishment of the college is enclosed or not</td>
                  <td>
                    <input type="radio" name="permissionOrder" value="Yes" checked={formik.values.permissionOrder === "Yes"} onChange={formik.handleChange} disabled={isDisabled} /> Yes &nbsp;
                    <input type="radio" name="permissionOrder" value="No" checked={formik.values.permissionOrder === "No"} onChange={formik.handleChange} disabled={isDisabled} /> No
                    <ErrorMessage name="permissionOrder" component="div" className="text-danger" />
                  </td>
                  <td>
                    <Field
                      as="textarea"
                      name="permissionOrderRemarks"
                      className="form-control"
                      placeholder="Remarks"
                      rows="3"
                      disabled={isDisabled}
                    />
                    {/* <ErrorMessage name="permissionOrderRemarks" component="div" className="text-danger" /> */}
                  </td>
                </tr>
                <tr>
                  <td className="text-center">6</td>
                  <td>Whether latest University affiliation order (2025-26) is enclosed or not</td>
                  <td>
                    {/* <label style={{ marginRight: "15px" }}> */}
                    <input type="radio" name="universityAffOrder" value="Yes" checked={formik.values.universityAffOrder === "Yes"} onChange={formik.handleChange} disabled={isDisabled} /> Yes &nbsp;
                    {/* </label> */}
                    {/* <label> */}
                    <input type="radio" name="universityAffOrder" value="No" checked={formik.values.universityAffOrder === "No"} onChange={formik.handleChange} disabled={isDisabled} /> No
                    {/* </label> */}
                    <ErrorMessage name="universityAffOrder" component="div" className="text-danger" />
                  </td>
                  <td>
                    <Field
                      as="textarea"
                      name="universityAffOrderRemarks"
                      className="form-control"
                      placeholder="Remarks"
                      rows="3"
                      disabled={isDisabled}
                    />
                    {/* <ErrorMessage name="universityAffOrderRemarks" component="div" className="text-danger" /> */}
                  </td>
                </tr>
                <tr>
                  <td className="text-center">7</td>
                  <td>The college is located in</td>
                  <td>
                    {corpusFundInstall[0]?.rural_area === "Yes"
                      ? "Rural/Tribal"
                      : corpusFundInstall[0]?.rural_area === "No"
                        ? "Urban"
                        : corpusFundInstall[0]?.rural_area || "-"}
                  </td>
                  <td>-</td>
                </tr>
                <tr>
                  <td className="text-center">8</td>
                  <td>Whether a copy of the last EoP granted is enclosed</td>
                  <td>
                    {/* <label style={{ marginRight: "15px" }}> */}
                    <input type="radio" name="lastEop" value="Yes" checked={formik.values.lastEop === "Yes"} onChange={formik.handleChange} disabled={isDisabled} /> Yes &nbsp;
                    {/* </label> */}
                    {/* <label> */}
                    <input type="radio" name="lastEop" value="No" checked={formik.values.lastEop === "No"} onChange={formik.handleChange} disabled={isDisabled} /> No
                    {/* </label> */}
                    <ErrorMessage name="lastEop" component="div" className="text-danger" />
                  </td>
                  <td>
                    <Field
                      as="textarea"
                      name="lastEopRemarks"
                      className="form-control"
                      placeholder="lastEopRemarks"
                      rows="3"
                      disabled={isDisabled}
                    />
                    {/* <ErrorMessage name="lastEopRemarks" component="div" className="text-danger" /> */}
                  </td>
                </tr>
                <tr>
                  <td colSpan="4" style={{ fontWeight: "bold", background: "#f1f1f1" }}>
                    9.Land
                  </td>
                </tr>
                <tr>
                  <td className="text-center">a.</td>
                  <td>Whether the society has own land as per norms</td>
                  <td>
                    <Field type="radio" name="landOwnedAsPerNorms" value="Yes" disabled={isDisabled} /> Yes &nbsp;
                    <Field type="radio" name="landOwnedAsPerNorms" value="No" disabled={isDisabled} /> No
                    <ErrorMessage name="landOwnedAsPerNorms" component="div" className="text-danger" />
                  </td>
                  <td>
                    <Field
                      as="textarea"
                      name="landOwnedAsPerNormsRemarks"
                      className="form-control"
                      placeholder="Remarks"
                      rows="3"
                      disabled={isDisabled}
                    />
                    {/* <ErrorMessage name="landOwnedAsPerNormsRemarks" component="div" className="text-danger" /> */}
                  </td>
                </tr>
                <tr>
                  <td className="text-center">b.</td>
                  <td>Whether the registered ownership of the land deed is produced</td>
                  <td>
                    <label>
                      <input
                        type="radio"
                        name="landDeedProduced"
                        value="Yes"
                        checked={formik.values.landDeedProduced === "Yes"}
                        onChange={formik.handleChange}
                        disabled={isDisabled}
                      />{" "}
                      Yes
                    </label>

                    <label className="ms-2">
                      <input
                        type="radio"
                        name="landDeedProduced"
                        value="No"
                        checked={formik.values.landDeedProduced === "No"}
                        onChange={formik.handleChange}
                        disabled={isDisabled}
                      />{" "}
                      No
                    </label>

                    <ErrorMessage name="landDeedProduced" component="div" className="text-danger" />
                  </td>
                  <td>
                    <Field
                      as="textarea"
                      name="landDeedProducedRemarks"
                      className="form-control"
                      placeholder="Remarks"
                      rows="3"
                      disabled={isDisabled}
                    />
                    {/* <ErrorMessage name="landDeedProducedRemarks" component="div" className="text-danger" /> */}
                  </td>
                </tr>
                <tr>
                  <td className="text-center">c.</td>
                  <td>Whether the registered document of the land owned in the name of the Society</td>
                  <td>
                    <label>
                      <input
                        type="radio"
                        name="landOwned"
                        value="Yes"
                        checked={formik.values.landOwned === "Yes"}
                        onChange={formik.handleChange}
                        disabled={isDisabled}
                      />{" "}
                      Yes
                    </label>

                    <label className="ms-2">
                      <input
                        type="radio"
                        name="landOwned"
                        value="No"
                        checked={formik.values.landOwned === "No"}
                        onChange={formik.handleChange}
                        disabled={isDisabled}
                      />{" "}
                      No
                    </label>

                    <ErrorMessage name="landOwned" component="div" className="text-danger" />
                  </td>
                  <td>
                    <Field
                      as="textarea"
                      name="landOwnedRemarks"
                      className="form-control"
                      placeholder="Remarks"
                      rows="3"
                      disabled={isDisabled}
                    />
                    {/* <ErrorMessage name="landOwnedRemarks" component="div" className="text-danger" /> */}
                  </td>
                </tr>
                <tr>
                  <td className="text-center">d.</td>
                  <td>Whether the own land is provided in the same Mandal</td>
                  <td>
                    <Field type="radio" name="landSameMandal" value="Yes" disabled={isDisabled} /> Yes &nbsp;
                    <Field type="radio" name="landSameMandal" value="No" disabled={isDisabled} /> No
                    <ErrorMessage name="landSameMandal" component="div" className="text-danger" />
                  </td>
                  <td>
                    <Field
                      as="textarea"
                      name="landSameMandalRemarks"
                      className="form-control"
                      placeholder="Remarks"
                      rows="3"
                      disabled={isDisabled}
                    />
                    {/* <ErrorMessage name="landSameMandalRemarks" component="div" className="text-danger" /> */}
                  </td>
                </tr>
                <tr>
                  <td className="text-center">e.</td>
                  <td>Mention distance of the land from the college building (in km)</td>
                  <td>{apiValues.distance || "-"}</td>
                  <td>-</td>
                </tr>
                <tr>
                  <td className="text-center">f.</td>
                  <td>Whether the sketch plan of own land drawn by the licensed surveyor and attested by the MRO is produced</td>
                  <td>
                    <input
                      type="radio"
                      name="sketchPlanProduced"
                      value="Yes"
                      checked={formik.values.sketchPlanProduced === "Yes"}
                      onChange={formik.handleChange}
                      disabled={isDisabled}
                    /> {" "} Yes &nbsp;
                    <input
                      type="radio"
                      name="sketchPlanProduced"
                      value="No"
                      checked={formik.values.sketchPlanProduced === "No"}
                      onChange={formik.handleChange}
                      disabled={isDisabled}
                    /> {" "}No
                    <ErrorMessage name="sketchPlanProduced" component="div" className="text-danger" />
                  </td>
                  <td>
                    <Field
                      as="textarea"
                      name="sketchPlanProducedRemarks"
                      className="form-control"
                      placeholder="Remarks"
                      rows="3"
                      disabled={isDisabled}
                    />
                    {/* <ErrorMessage name="sketchPlanProducedRemarks" component="div" className="text-danger" /> */}
                  </td>
                </tr>
                <tr>
                  <td className="text-center">g.</td>
                  <td>Whether the schedule of property mentioned in the registered ownership deed is tallying with the sketch plan produced</td>
                  <td>
                    <input
                      type="radio"
                      name="scheduledProperty"
                      value="Yes"
                      checked={formik.values.scheduledProperty === "Yes"}
                      onChange={formik.handleChange}
                      disabled={isDisabled}
                    /> {" "} Yes &nbsp;
                    <input
                      type="radio"
                      name="scheduledProperty"
                      value="No"
                      checked={formik.values.scheduledProperty === "No"}
                      onChange={formik.handleChange}
                      disabled={isDisabled}
                    /> {" "} No
                    <ErrorMessage name="scheduledProperty" component="div" className="text-danger" />
                  </td>
                  <td>
                    <Field
                      as="textarea"
                      name="scheduledPropertyRemarks"
                      className="form-control"
                      placeholder="Remarks"
                      rows="3"
                      disabled={isDisabled}
                    />
                    {/* <ErrorMessage name="scheduledPropertyRemarks" component="div" className="text-danger" /> */}
                  </td>
                </tr>
                <tr>
                  <td colSpan="4" style={{ fontWeight: "bold", background: "#f1f1f1" }}>
                    10.  Building Accommodation
                  </td>
                </tr>
                <tr>
                  <td className="text-center">a.</td>
                  <td>Whether registered lease deed of the building is in the name of the college / society is produced</td>
                  <td>
                    <Field type="radio" name="leaseDeedProduced" value="Yes" disabled={isDisabled} /> Yes &nbsp;
                    <Field type="radio" name="leaseDeedProduced" value="No" disabled={isDisabled} /> No
                    <ErrorMessage name="leaseDeedProduced" component="div" className="text-danger" />
                  </td>
                  <td>
                    <Field
                      as="textarea"
                      name="leaseDeedProducedRemarks"
                      className="form-control"
                      placeholder="Remarks"
                      rows="3"
                      disabled={isDisabled}
                    />
                    <ErrorMessage name="leaseDeedProducedRemarks" component="div" className="text-danger" />
                  </td>
                </tr>
                <tr>
                  <td className="text-center">b.</td>
                  <td>Mention the validity of the lease period: From & To-date</td>
                  <td>
                    <td>
                      <div className="d-flex align-items-center gap-2">
                        <input
                          type="date"
                          name="leaseFromDate"
                          className="form-control form-control-sm"
                          value={formik.values.leaseFromDate || ""}
                          onChange={formik.handleChange}
                          onBlur={formik.handleBlur}
                          disabled={isDisabled}
                          style={{ width: "auto" }}
                          min="1900-01-01"
                          max="2100-12-31"
                        // max={new Date().toISOString().split("T")[0]}
                        />
                        <span>to</span>
                        <input
                          type="date"
                          name="leaseToDate"
                          className="form-control form-control-sm"
                          value={formik.values.leaseToDate || ""}
                          onChange={formik.handleChange}
                          onBlur={formik.handleBlur}
                          disabled={isDisabled}
                          style={{ width: "auto" }}
                          min="1900-01-01"
                          max="2100-12-31"
                        // max={new Date().toISOString().split("T")[0]}
                        />
                      </div>
                      <div className="d-flex gap-3 mt-1">
                        <ErrorMessage
                          name="leaseFromDate"
                          component="div"
                          className="text-danger small"
                        />
                        <ErrorMessage
                          name="leaseToDate"
                          component="div"
                          className="text-danger small"
                        />
                      </div>
                    </td>
                  </td>
                  <td>
                    <Field
                      as="textarea"
                      name="leaseFromDateRemarks"
                      className="form-control"
                      placeholder="Remarks"
                      rows="3"
                      disabled={isDisabled}
                    />
                    {/* <ErrorMessage name="leaseFromDateRemarks" component="div" className="text-danger" /> */}
                  </td>
                </tr>
                <tr>
                  <td className="text-center">c.</td>
                  <td>Mention total no. of years completed in leased building From the date of establishment</td>
                  <td>        <Field
                    type="text"
                    name="totalYears"
                    className="form-control mb-2"
                    placeholder="Enter total years"
                    disabled={isDisabled}
                    value={2026 - apiValues.year_of_establishment}
                  />
                    <ErrorMessage name="totalYears" component="div" className="text-danger" /></td>
                  <td>
                    <Field
                      as="textarea"
                      name="totalYearsRemarks"
                      className="form-control"
                      placeholder="Remarks"
                      rows="3"
                      disabled={isDisabled}
                    />
                    {/* <ErrorMessage name="totalYearsRemarks" component="div" className="text-danger" /> */}
                  </td>
                </tr>

                <tr>
                  <td className="text-center">d.</td>
                  <td>Whether building plan is approved by competent authority for running institution</td>
                  <td>
                    <label>
                      <input type="radio" name="buildingPlanApproved" value="Yes" checked={formik.values.buildingPlanApproved === "Yes"} onChange={formik.handleChange} disabled={isDisabled} /> Yes
                    </label>
                    <label className="ms-2">
                      <input type="radio" name="buildingPlanApproved" value="No" checked={formik.values.buildingPlanApproved === "No"} onChange={formik.handleChange} disabled={isDisabled} /> No
                    </label>
                    <ErrorMessage name="buildingPlanApproved" component="div" className="text-danger" />
                  </td>
                  <td>
                    <Field
                      as="textarea"
                      name="buildingPlanApprovedRemarks"
                      className="form-control"
                      placeholder="Remarks"
                      rows="3"
                      disabled={isDisabled}
                    />
                    {/* <ErrorMessage name="buildingPlanApprovedRemarks" component="div" className="text-danger" /> */}
                  </td>
                </tr>

                <tr>
                  <td className="text-center">e.</td>
                  <td>Whether approved plan drawn by licensed surveyor is produced</td>
                  <td>
                    <label>
                      <input type="radio" name="buildingPlanLicensed" value="Yes" checked={formik.values.buildingPlanLicensed === "Yes"} onChange={formik.handleChange} disabled={isDisabled} /> Yes
                    </label>
                    <label className="ms-2">
                      <input type="radio" name="buildingPlanLicensed" value="No" checked={formik.values.buildingPlanLicensed === "No"} onChange={formik.handleChange} disabled={isDisabled} /> No
                    </label>
                    <ErrorMessage name="buildingPlanLicensed" component="div" className="text-danger" />
                  </td>
                  <td>
                    <Field
                      as="textarea"
                      name="buildingPlanLicensedRemarks"
                      className="form-control"
                      placeholder="Remarks"
                      rows="3"
                      disabled={isDisabled}
                    />
                    {/* <ErrorMessage name="buildingPlanLicensedRemarks" component="div" className="text-danger" /> */}
                  </td>
                </tr>

                <tr>
                  <td className="text-center">f.</td>
                  <td>Whether total plinth area is as per norms</td>
                  <td>
                    <label>
                      <input type="radio" name="buildingPlinthArea" value="Yes" checked={formik.values.buildingPlinthArea === "Yes"} onChange={formik.handleChange} disabled={isDisabled} /> Yes
                    </label>
                    <label className="ms-2">
                      <input type="radio" name="buildingPlinthArea" value="No" checked={formik.values.buildingPlinthArea === "No"} onChange={formik.handleChange} disabled={isDisabled} /> No
                    </label>
                    <ErrorMessage name="buildingPlinthArea" component="div" className="text-danger" />
                  </td>
                  <td>
                    <Field
                      as="textarea"
                      name="buildingPlinthAreaRemarks"
                      className="form-control"
                      placeholder="Remarks"
                      rows="3"
                      disabled={isDisabled}
                    />
                    {/* <ErrorMessage name="buildingPlinthAreaRemarks" component="div" className="text-danger" /> */}
                  </td>
                </tr>

                <tr>
                  <td className="text-center">g.</td>
                  <td> Whether construction permission order issued by competent authority is produced</td>
                  <td>
                    <label>
                      <input type="radio" name="buildingConstructionPermission" value="Yes" checked={formik.values.buildingConstructionPermission === "Yes"} onChange={formik.handleChange} disabled={isDisabled} /> Yes
                    </label>
                    <label className="ms-2">
                      <input type="radio" name="buildingConstructionPermission" value="No" checked={formik.values.buildingConstructionPermission === "No"} onChange={formik.handleChange} disabled={isDisabled} /> No
                    </label>
                    <ErrorMessage name="buildingConstructionPermission" component="div" className="text-danger" />
                  </td>
                  <td>
                    <Field
                      as="textarea"
                      name="buildingConstructionPermissionRemarks"
                      className="form-control"
                      placeholder="Remarks"
                      rows="3"
                      disabled={isDisabled}
                    />
                    {/* <ErrorMessage name="buildingConstructionPermissionRemarks" component="div" className="text-danger" /> */}
                  </td>
                </tr>

                <tr>
                  <td className="text-center">h.</td>
                  <td>Whether valid sanitary certificate is produced</td>
                  <td>
                    <label>
                      <input type="radio" name="buildingSanitaryCertificate" value="Yes" checked={formik.values.buildingSanitaryCertificate === "Yes"} onChange={formik.handleChange} disabled={isDisabled} /> Yes
                    </label>
                    <label className="ms-2">
                      <input type="radio" name="buildingSanitaryCertificate" value="No" checked={formik.values.buildingSanitaryCertificate === "No"} onChange={formik.handleChange} disabled={isDisabled} /> No
                    </label>
                    <ErrorMessage name="buildingSanitaryCertificate" component="div" className="text-danger" />
                  </td>
                  <td>
                    <Field
                      as="textarea"
                      name="buildingSanitaryCertificateRemarks"
                      className="form-control"
                      placeholder="Remarks"
                      rows="3"
                      disabled={isDisabled}
                    />
                    {/* <ErrorMessage name="buildingSanitaryCertificateRemarks" component="div" className="text-danger" /> */}
                  </td>
                </tr>

                <tr>
                  <td className="text-center">i.</td>
                  <td>Whether latest geo-tagged building photographs and attested by the by the Principal of a Government College are produced</td>
                  <td>
                    <label>
                      <input type="radio" name="buildingBuildingPhotographs" value="Yes" checked={formik.values.buildingBuildingPhotographs === "Yes"} onChange={formik.handleChange} disabled={isDisabled} /> Yes
                    </label>
                    <label className="ms-2">
                      <input type="radio" name="buildingBuildingPhotographs" value="No" checked={formik.values.buildingBuildingPhotographs === "No"} onChange={formik.handleChange} disabled={isDisabled} /> No
                    </label>
                    <ErrorMessage name="buildingBuildingPhotographs" component="div" className="text-danger" />
                  </td>
                  <td>
                    <Field
                      as="textarea"
                      name="buildingBuildingPhotographsRemarks"
                      className="form-control"
                      placeholder="Remarks"
                      rows="3"
                      disabled={isDisabled}
                    />
                    {/* <ErrorMessage name="buildingBuildingPhotographsRemarks" component="div" className="text-danger" /> */}
                  </td>
                </tr>

                <tr>
                  <td className="text-center">j.</td>
                  <td>Whether any other institution is running in same building</td>
                  <td>
                    <label>
                      <input
                        type="radio"
                        name="runningInstitutionSameBuilding"
                        value="Yes"
                        checked={formik.values.runningInstitutionSameBuilding === "Yes"}
                        disabled={isDisabled}
                        onChange={(e) => { formik.handleChange(e); clearDependentFields("runningInstitutionSameBuilding", e.target.value); }}
                      />
                      Yes
                    </label>

                    <label style={{ marginLeft: "10px" }}>
                      <input
                        type="radio"
                        name="runningInstitutionSameBuilding"
                        value="No"
                        checked={formik.values.runningInstitutionSameBuilding === "No"}
                        disabled={isDisabled}
                        onChange={(e) => { formik.handleChange(e); clearDependentFields("runningInstitutionSameBuilding", e.target.value); }}
                      />
                      No
                    </label>
                    <ErrorMessage name="runningInstitutionSameBuilding" component="div" className="text-danger" />
                  </td>
                  <td>
                    <Field
                      as="textarea"
                      name="runningInstitutionSameBuildingRemarks"
                      className="form-control"
                      placeholder="Remarks"
                      rows="3"
                      disabled={isDisabled}
                    />
                    {/* <ErrorMessage name="runningInstitutionSameBuildingRemarks" component="div" className="text-danger" /> */}
                  </td>
                </tr>
                {formik.values.runningInstitutionSameBuilding === "Yes" && (
                  <tr>
                    <td className="text-center">(j)1</td>
                    <td> whether a copy of the NoC from the concerned authority to utilize part of the building, which is not being utilized by the other institution, for running this institution is produced</td>
                    <td>
                      <Field type="radio" name="nocProduced" value="Yes" disabled={isDisabled} /> Yes &nbsp;
                      <Field type="radio" name="nocProduced" value="No" disabled={isDisabled} /> No
                      <ErrorMessage name="nocProduced" component="div" className="text-danger" />
                    </td>
                    <td>
                      <Field
                        as="textarea"
                        name="nocProducedRemarks"
                        className="form-control"
                        placeholder="Remarks"
                        rows="3"
                        disabled={isDisabled}
                      />
                      {/* <ErrorMessage name="nocProducedRemarks" component="div" className="text-danger" /> */}
                    </td>
                  </tr>
                )}
                <tr>
                  <td className="text-center">k.</td>
                  <td>Whether the details of existing building accommodation provided in Annexure-I are in accordance with the stipulated norms</td>
                  <td>
                    <label>
                      <input type="radio" name="buildingMatchAnnexure" value="Yes" checked={formik.values.buildingMatchAnnexure === "Yes"} onChange={formik.handleChange} disabled={isDisabled} /> Yes
                    </label>
                    <label className="ms-2">
                      <input type="radio" name="buildingMatchAnnexure" value="No" checked={formik.values.buildingMatchAnnexure === "No"} onChange={formik.handleChange} disabled={isDisabled} /> No
                    </label>
                    <ErrorMessage name="buildingMatchAnnexure" component="div" className="text-danger" />
                  </td>
                  <td>
                    <Field
                      as="textarea"
                      name="buildingMatchAnnexureRemarks"
                      className="form-control"
                      placeholder="Remarks"
                      rows="3"
                      disabled={isDisabled}
                    />
                    {/* <ErrorMessage name="buildingMatchAnnexureRemarks" component="div" className="text-danger" /> */}
                  </td>
                </tr>

                <tr>
                  <td className="text-center">l.</td>
                  <td>Whether the Leased period is Valid/ Expired ?</td>
                  <td>
                    <label>
                      <input type="radio" name="validOrExpired" value="Yes" checked={formik.values.validOrExpired === "Yes"} onChange={formik.handleChange} disabled={isDisabled} /> Valid
                    </label>
                    <label className="ms-2">
                      <input type="radio" name="validOrExpired" value="No" checked={formik.values.validOrExpired === "No"} onChange={formik.handleChange} disabled={isDisabled} /> &nbsp;Expired
                    </label>
                    <ErrorMessage name="validOrExpired" component="div" className="text-danger" />
                  </td>
                  <td>
                    <Field
                      as="textarea"
                      name="validOrExpiredRemarks"
                      className="form-control"
                      placeholder="Remarks"
                      rows="3"
                      disabled={isDisabled}
                    />
                    {/* <ErrorMessage name="validOrExpiredRemarks" component="div" className="text-danger" /> */}
                  </td>
                </tr>
              </tbody>
            </Table>
            {getAccomidation?.length > 0 && (<>
              <React.Fragment key={getAccomidation.length}>
                <h5 className="text-success mb-3">Accommodation required & provided for existing PG /UG programmes </h5>
                <Table bordered responsive>
                  <thead className="table-primary text-center">
                    <tr>
                      <th>Sl. No.</th>
                      <th>Type of the room</th>
                      <th>No. of room(s) required</th>
                      <th>Total carpet area (sft) required</th>
                      <th>No. of room(s) provided</th>
                      <th>Total carpet area (sft) provided</th>
                      <th>Whether sufficient as per norms</th>
                      <th>Remarks</th>
                    </tr>
                  </thead>
                  <tbody>
                    {getAccomidation?.map((item, index) => (
                      <tr key={index}>
                        <td className="text-center">{index + 1}</td>
                        <td>{item?.particular_name}</td>
                        <td>{item?.no_of_rooms}</td>
                        <td>{item.total_area}</td>
                        <td>{item?.no_of_rooms}</td>
                        <td>{item?.total_area}</td>
                        <td>
                          <label>
                            <input type="radio" name={`accomodation.${index}.sufficientAsPerNorms`} value="Yes" checked={formik.values.accomodation?.[index]?.sufficientAsPerNorms === "Yes"} onChange={formik.handleChange} disabled={isDisabled} onBlur={formik.handleBlur} /> Yes
                          </label>
                          <label className="ms-2">
                            <input type="radio" name={`accomodation.${index}.sufficientAsPerNorms`} value="No" checked={formik.values.accomodation?.[index]?.sufficientAsPerNorms === "No"} onChange={formik.handleChange} disabled={isDisabled} onBlur={formik.handleBlur} />  No
                          </label>
                          <ErrorMessage name={`accomodation.${index}.sufficientAsPerNorms`} component="div" className="text-danger" />
                        </td>
                        <td>
                          <input type="text" className="form-control" name={`accomodation.${index}.remarks`}
                            value={formik.values.accomodation?.[index]?.remarks || ''}
                            onChange={formik.handleChange}
                            onBlur={formik.handleBlur}
                            disabled={isDisabled} />
                          {/* <ErrorMessage
                            name={`accomodation.${index}.remarks`}
                            component="div"
                            className="text-danger"
                          /> */}
                        </td>
                      </tr>
                    ))}
                  </tbody>
                </Table>
              </React.Fragment>
            </>)}
            <Row>
              <Col>
                {/* Parking Table */}
                <h5 className="text-success mb-3"> 11. Parking</h5>
                <Table bordered responsive>
                  <thead className="table-primary text-center">
                    <tr>
                      <th>Sl. No.</th>
                      <th>Particulars</th>
                      <th>Status</th>
                      <th style={{ width: "20%" }}>Remarks</th>
                    </tr>
                  </thead>
                  <tbody>
                    <tr>
                      <td className="text-center">a.</td>
                      <td>Whether the parking area is available in the same premises</td>
                      <td>

                        <input type="radio" name="parkingAvailable" value="Yes" checked={formik.values.parkingAvailable === "Yes"} disabled={isDisabled} onChange={(e) => { formik.handleChange(e); clearDependentFields("parkingAvailable", e.target.value); }} /> Yes &nbsp;
                        <input type="radio" name="parkingAvailable" value="No" checked={formik.values.parkingAvailable === "No"} disabled={isDisabled} onChange={(e) => { formik.handleChange(e); clearDependentFields("parkingAvailable", e.target.value); }} /> No
                        <ErrorMessage name="parkingAvailable" component="div" className="text-danger" />
                      </td>
                      <td>
                        <Field
                          as="textarea"
                          name="parkingAvailableRemarks"
                          className="form-control"
                          placeholder="Remarks"
                          rows="3"
                          disabled={isDisabled}
                        />
                        {/* <ErrorMessage name="parkingAvailableRemarks" component="div" className="text-danger" /> */}
                      </td>

                    </tr>
                    {formik.values.parkingAvailable === "No" && (
                      <tr>
                        <td className="text-center">a.1</td>
                        <td>If not in the same premises, whether the parking area provided within a distance of 100 meters thereof</td>
                        <td>
                          <input type="radio" name="parkingWithin100Meters" value="Yes" checked={formik.values.parkingWithin100Meters === "Yes"} disabled={isDisabled} onBlur={formik.handleBlur} onChange={(e) => { formik.handleChange(e); clearDependentFields("parkingWithin100Meters", e.target.value); }} /> Yes &nbsp;
                          <input type="radio" name="parkingWithin100Meters" value="No" checked={formik.values.parkingWithin100Meters === "No"} disabled={isDisabled} onBlur={formik.handleBlur} onChange={(e) => { formik.handleChange(e); clearDependentFields("parkingWithin100Meters", e.target.value); }} /> No
                          <ErrorMessage name="parkingWithin100Meters" component="div" className="text-danger" />
                        </td>
                        <td>
                          <Field
                            as="textarea"
                            name="parkingWithin100MetersRemarks"
                            className="form-control"
                            placeholder="Remarks"
                            rows="3"
                            disabled={isDisabled}
                          />
                          {/* <ErrorMessage name="parkingWithin100MetersRemarks" component="div" className="text-danger" /> */}
                        </td>
                      </tr>
                    )}
                    {/* a.2 */}
                    {formik.values.parkingAvailable === "No" && formik.values.parkingWithin100Meters === "Yes" && (
                      <tr>
                        <td className="text-center">a.2</td>
                        {/* <td>Upload the document for proof of parking area within 100 meters</td> */}

                        <td>
                          Whether the document is uploaded for proof of parking area with in 100 meters
                        </td>
                        <td>
                          <input
                            type="radio"
                            name="parkingAreaWithin100mDocUploaded"
                            value="Yes"
                            checked={formik.values.parkingAreaWithin100mDocUploaded === "Yes"}
                            disabled={isDisabled}
                            onChange={(e) => {
                              formik.handleChange(e);
                              clearDependentFields("parkingAreaWithin100mDocUploaded", e.target.value);
                            }}
                          />  &nbsp;Yes &nbsp;
                          <input
                            type="radio"
                            name="parkingAreaWithin100mDocUploaded"
                            value="No"
                            checked={formik.values.parkingAreaWithin100mDocUploaded === "No"}
                            disabled={isDisabled}
                            onChange={(e) => {
                              formik.handleChange(e);
                              clearDependentFields("parkingAreaWithin100mDocUploaded", e.target.value);
                            }}
                          /> &nbsp; No
                          <ErrorMessage name="parkingAreaWithin100mDocUploaded" component="div" className="text-danger" />
                        </td>

                        {/* <input
                            type="file"
                            className="form-control"
                            name="parkingAreaWithin100mDocUploaded"
                            accept="application/pdf"
                            onChange={(e) => {
                              let filename = `parkingAreaWithin100m`;
                              let path = "/Uploads/ParkingDocument/";
                              ImagePdfBucket(e, formik, path, "parkingAreaWithin100mDocUploaded", filename, "pdf");
                            }}
                          /> */}

                        {/* {formik.values.parkingAreaWithin100mDocUploaded && (
                            <button
                              type="button"
                              className="btn btn-link p-0 text-primary mt-2"
                              onClick={() => viewImage(formik.values.parkingAreaWithin100mDocUploaded)}
                            >
                              <FaEye size={20} /> View Document
                            </button>
                          )} */}

                        {/* <Field type="hidden" name="parkingAreaWithin100mDocUploaded" /> */}
                        {/* <ErrorMessage name="parkingAreaWithin100mDocUploaded" component="div" className="text-danger" /> */}

                        <td>
                          <Field
                            as="textarea"
                            name="parkingAreaDocUploadedRemarks"
                            className="form-control"
                            placeholder="Remarks"
                            rows="3"
                            disabled={isDisabled}
                          />
                          {/* <ErrorMessage name="parkingAreaDocUploadedRemarks" component="div" className="text-danger" /> */}
                        </td>
                      </tr>
                    )}
                    {formik.values.parkingAvailable === "Yes" && (<tr>
                      <td className="text-center">b.</td>
                      <td>Whether 20% of the total built up area is provided for the Parking area</td>
                      <td onBlur={() => {
                        formik.setFieldTouched("parkingArea20Percent", true);
                      }}>
                        <Field type="radio" name="parkingArea20Percent" value="Yes" disabled={isDisabled} /> Yes &nbsp;
                        <Field type="radio" name="parkingArea20Percent" value="No" disabled={isDisabled} /> No
                        <ErrorMessage name="parkingArea20Percent" component="div" className="text-danger" />

                      </td>
                      <td>
                        <Field
                          as="textarea"
                          name="parkingArea20PercentRemarks"
                          className="form-control"
                          placeholder="Remarks"
                          rows="3"
                          disabled={isDisabled}
                        />
                        {/* <ErrorMessage name="parkingArea20PercentRemarks" component="div" className="text-danger" /> */}
                      </td>
                    </tr>)}


                  </tbody>
                </Table>

                {/* Playground Table - Separate Table */}
                <h5 className="text-success mb-3 mt-4">12.Playground</h5>
                <Table bordered responsive>
                  <thead className="table-primary text-center">
                    <tr>
                      <th>Sl. No.</th>
                      <th>Particulars</th>
                      <th>Status</th>
                      <th style={{ width: "20%" }}>Remarks</th>
                    </tr>
                  </thead>
                  <tbody>
                    <tr>
                      <td className="text-center">a.</td>
                      <td>Whether the Playground facility is available in the same premises</td>
                      <td>
                        <input type="radio" name="playgroundAvailable" value="Yes" checked={formik.values.playgroundAvailable === "Yes"} disabled={isDisabled} onChange={(e) => { formik.handleChange(e); clearDependentFields("playgroundAvailable", e.target.value); }} /> Yes &nbsp;
                        <input type="radio" name="playgroundAvailable" value="No" checked={formik.values.playgroundAvailable === "No"} disabled={isDisabled} onChange={(e) => { formik.handleChange(e); clearDependentFields("playgroundAvailable", e.target.value); }} /> No
                        <ErrorMessage name="playgroundAvailable" component="div" className="text-danger" />

                      </td>
                      <td>
                        <Field
                          as="textarea"
                          name="playgroundAvailableRemarks"
                          className="form-control"
                          placeholder="Remarks"
                          rows="3"
                          disabled={isDisabled}
                        />
                        {/* <ErrorMessage name="playgroundAvailableRemarks" component="div" className="text-danger" /> */}
                      </td>
                    </tr>
                    {formik.values.playgroundAvailable === "Yes" && (
                      <tr>
                        <td className="text-center">a.1</td>
                        <td>Mention the extent of the playground facility available (sft)</td>
                        <td>
                          <Field type="text" name="playgroundExtent" className="form-control" placeholder="Enter extent in sft" disabled={isDisabled} />
                          <ErrorMessage name="playgroundExtent" component="div" className="text-danger" />
                        </td>
                        <td>
                          <Field
                            as="textarea"
                            name="playgroundExtentRemarks"
                            className="form-control"
                            placeholder="Remarks"
                            rows="3"
                            disabled={isDisabled}
                          />
                          {/* <ErrorMessage name="playgroundExtentRemarks" component="div" className="text-danger" /> */}
                        </td>
                      </tr>
                    )}
                    {formik.values.playgroundAvailable === "No" && (
                      <tr>
                        <td className="text-center">b.</td>
                        <td>If not, whether any alternative arrangement for playground is provided within a radius of 5 kms along with bus facility</td>
                        <td>
                          <input type="radio" name="alternativePlayground" value="Yes" checked={formik.values.alternativePlayground === "Yes"} disabled={isDisabled} onChange={(e) => { formik.handleChange(e); clearDependentFields("alternativePlayground", e.target.value); }} /> Yes &nbsp;
                          <input type="radio" name="alternativePlayground" value="No" checked={formik.values.alternativePlayground === "No"} disabled={isDisabled} onChange={(e) => { formik.handleChange(e); clearDependentFields("alternativePlayground", e.target.value); }} /> No
                          <ErrorMessage name="alternativePlayground" component="div" className="text-danger" />
                        </td>
                        <td>
                          <Field
                            as="textarea"
                            name="alternativePlaygroundRemarks"
                            className="form-control"
                            placeholder="Remarks"
                            rows="3"
                            disabled={isDisabled}
                          />
                          {/* <ErrorMessage name="alternativePlaygroundRemarks" component="div" className="text-danger" /> */}
                        </td>
                      </tr>
                    )}
                    {formik.values.alternativePlayground === "Yes" && (
                      <tr>
                        <td className="text-center">c.</td>
                        <td>Whether MoU for utilization of the alternative facility for playground is produced</td>
                        <td>
                          <Field type="radio" name="playgroundMoU" value="Yes" disabled={isDisabled} /> Yes &nbsp;
                          <Field type="radio" name="playgroundMoU" value="No" disabled={isDisabled} /> No
                          <ErrorMessage name="playgroundMoU" component="div" className="text-danger" />
                        </td>
                        <td>
                          <Field
                            as="textarea"
                            name="playgroundMoURemarks"
                            className="form-control"
                            placeholder="Remarks"
                            rows="3"
                            disabled={isDisabled}
                          />
                          {/* <ErrorMessage name="playgroundMoURemarks" component="div" className="text-danger" /> */}
                        </td>
                      </tr>
                    )}

                  </tbody>
                </Table >

                <Table bordered responsive>
                  <thead className="table-primary text-center">
                    <tr>
                      <th>Sl. No.</th>
                      <th>Particular</th>
                      <th>Action</th>
                      <th style={{ width: "20%" }}>Remarks</th>

                    </tr>
                  </thead>
                  <tbody>
                    <tr>
                      <td className="text-center">13</td>
                      <td>Whether valid fire safety certificate </td>
                      <td>
                        <input type="radio" name="parkingExemptedCases" value="Yes" checked={formik.values.parkingExemptedCases === "Yes"} onChange={formik.handleChange} disabled={isDisabled} /> Yes
                        <input type="radio" name="parkingExemptedCases" value="No" className="ms-2" checked={formik.values.parkingExemptedCases === "No"} onChange={formik.handleChange} disabled={isDisabled} /> No
                        <ErrorMessage name="parkingExemptedCases" component="div" className="text-danger" />
                      </td>
                      <td>
                        <Field
                          as="textarea"
                          name="parkingExemptedCasesRemarks"
                          className="form-control"
                          placeholder="Remarks"
                          rows="3"
                          disabled={isDisabled}
                        />
                        {/* <ErrorMessage name="parkingExemptedCasesRemarks" component="div" className="text-danger" /> */}
                      </td>
                    </tr>
                    <tr>
                      <td className="text-center">14</td>
                      <td>Latest affidavit for exempted cases is produced</td>
                      <td>
                        <input type="radio" name="latestAffidavit" value="Yes" checked={formik.values.latestAffidavit === "Yes"} onChange={formik.handleChange} disabled={isDisabled} /> Yes
                        <input type="radio" name="latestAffidavit" value="No" className="ms-2" checked={formik.values.latestAffidavit === "No"} onChange={formik.handleChange} disabled={isDisabled} /> No
                        <ErrorMessage name="latestAffidavit" component="div" className="text-danger" />
                      </td>
                      <td>
                        <Field
                          as="textarea"
                          name="latestAffidavitRemarks"
                          className="form-control"
                          placeholder="Remarks"
                          rows="3"
                          disabled={isDisabled}
                        />
                        {/* <ErrorMessage name="latestAffidavitRemarks" component="div" className="text-danger" /> */}
                      </td>
                    </tr>
                  </tbody>
                </Table>
                {getUgCourses.length > 0 && (<>
                  <h5 className="text-success mb-3">Details of the UG programmes</h5>
                  <Table bordered responsive>
                    <thead className="table-primary text-center">
                      <tr>
                        <th>Sl. No.</th>
                        <th>Type of the UG Programme</th>
                        <th>Total No. of programmes</th>
                        <th>Sanctioned Intake</th>
                      </tr>
                    </thead>
                    <tbody>
                      {getUgCourses?.map((item, index) => (
                        <tr key={index}>
                          <td className="text-center">{index + 1}</td>
                          <td>{item?.course_cat_name}</td>
                          <td>{item?.count}</td>
                          <td>{item?.sum}</td>
                        </tr>
                      ))}
                    </tbody>
                  </Table></>)}
                {pgCourses && pgCourses.length > 0 && (
                  <>
                    <h5 className="text-success mb-3">Details of the PG programmes</h5>
                    <Table bordered responsive>
                      <thead className="table-primary text-center">
                        <tr>
                          <th>Sl. No.</th>
                          <th>Type of the PG Programme</th>
                          <th>Total No. of programmes</th>
                          <th>Sanctioned Intake</th>
                        </tr>
                      </thead>
                      <tbody>
                        {pgCourses?.map((item, index) => (
                          <tr key={index}>
                            <td className="text-center">{index + 1}</td>
                            <td>{item.course_cat_name}</td>
                            <td>{item.count}</td>
                            <td>{item.sum}</td>
                          </tr>
                        ))}
                      </tbody>
                    </Table>
                  </>
                )}
                <h5 className="text-success mb-3">14.Corpus Fund</h5>
                <table className="table table-bordered">
                  <thead className="table-primary text-center">
                    <tr>
                      <th style={{ width: "5%" }}>Sl.No</th>
                      <th style={{ width: "60%" }}>Particulars</th>
                      <th style={{ width: "10%" }}>Action</th>
                      <th style={{ width: "20%" }}>Remarks</th>
                    </tr>
                  </thead>
                  <tbody>
                    <tr>
                      <td className="text-center">a.</td>
                      <td>
                        Whether the college was exempted from paying the Corpus Fund:
                      </td>

                      <td>
                        <input
                          type="radio"
                          name="corpusFund"
                          value="Yes"
                          onChange={(e) => { formik.handleChange(e); clearDependentFields("corpusFund", e.target.value); }}
                          checked={formik.values.corpusFund === "Yes"}
                          disabled={isDisabled}
                        />{" "}
                        Yes

                        <input
                          type="radio"
                          name="corpusFund"
                          value="No"
                          className="ms-3"
                          onChange={(e) => { formik.handleChange(e); clearDependentFields("corpusFund", e.target.value); }}
                          checked={formik.values.corpusFund === "No"}
                          disabled={isDisabled}
                        />{" "}
                        No
                        <ErrorMessage name="corpusFund" component="div" className="text-danger" />
                      </td>
                      <td>
                        <Field
                          as="textarea"
                          name="corpusFundRemarks"
                          className="form-control"
                          placeholder="Remarks"
                          rows="3"
                          disabled={isDisabled}
                        />
                        {/* <ErrorMessage name="corpusFundRemarks" component="div" className="text-danger" /> */}
                      </td>

                    </tr>
                    {formik.values.corpusFund === "Yes" && (
                      <tr>
                        <td className="text-center">b.</td>

                        <td>
                          whether the rural/tribal area certificate issued by MRO is produced:
                        </td>

                        <td>
                          <input
                            type="radio"
                            name="certificateIssued"
                            value="Yes"
                            onChange={formik.handleChange}
                            onBlur={formik.handleBlur}
                            checked={formik.values.certificateIssued === "Yes"}
                            disabled={isDisabled}
                          />{" "}
                          Yes

                          <input
                            type="radio"
                            name="certificateIssued"
                            value="No"
                            className="ms-3"
                            onChange={formik.handleChange}
                            onBlur={formik.handleBlur}
                            checked={formik.values.certificateIssued === "No"}
                            disabled={isDisabled}
                          />{" "}
                          No

                          <ErrorMessage
                            name="certificateIssued"
                            component="div"
                            className="text-danger"
                          />
                        </td>
                        <td>
                          <Field
                            as="textarea"
                            name="certificateIssuedRemarks"
                            className="form-control"
                            placeholder="Remarks"
                            rows="3"
                            disabled={isDisabled}
                          />
                          {/* <ErrorMessage name="certificateIssuedRemarks" component="div" className="text-danger" /> */}
                        </td>
                      </tr>
                    )}

                  </tbody>
                </table>
                {formik.values.corpusFund === "No" && (
                  <>
                    {/* For Degree Colleges established before 2021-22 - Using corpusFundInstall data */}
                    {corpusFundInstall.length > 0 && (<>
                      <h5 className="text-success mb-3">For Degree Colleges established before 2021-22</h5>
                      <Table bordered responsive>
                        <thead className="table-primary text-center">
                          <tr>
                            <th rowSpan={2}>Required Information</th>
                            <th colSpan={3}>Installments</th>
                          </tr>
                          <tr>
                            <th>First</th>
                            <th>Second</th>
                            <th>Third</th>
                          </tr>
                        </thead>
                        <tbody>
                          <tr>
                            <td>Amount</td>
                            <td>{firstInstallment.amount || "-"}</td>
                            <td>{secondInstallment.amount || "-"}</td>
                            <td>{thirdInstallment.amount || "-"}</td>
                          </tr>
                          <tr>
                            <td>Period (from - to)</td>
                            <td>{firstInstallment.from_date ? `${firstInstallment.from_date} - ${firstInstallment.to_date}` : "-"}</td>
                            <td>{secondInstallment.from_date ? `${secondInstallment.from_date} - ${secondInstallment.to_date}` : "-"}</td>
                            <td>{thirdInstallment.from_date ? `${thirdInstallment.from_date} - ${thirdInstallment.to_date}` : "-"}</td>
                          </tr>
                          <tr>
                            <td>Date of FDR</td>
                            <td>{firstInstallment.date_of_fdr || "-"}</td>
                            <td>{secondInstallment.date_of_fdr || "-"}</td>
                            <td>{thirdInstallment.date_of_fdr || "-"}</td>
                          </tr>
                          <tr>
                            <td>Name & address of the Issuing Bank</td>
                            <td>{firstInstallment.bank_address || "-"}</td>
                            <td>{secondInstallment.bank_address || "-"}</td>
                            <td>{thirdInstallment.bank_address || "-"}</td>
                          </tr>
                          <tr>
                            <td>IFSC CODE</td>
                            <td>{firstInstallment.ifsc || "-"}</td>
                            <td>{secondInstallment.ifsc || "-"}</td>
                            <td>{thirdInstallment.ifsc || "-"}</td>
                          </tr>
                          <tr>
                            <td>Date of maturity</td>
                            <td>{firstInstallment.date_of_maturity || "-"}</td>
                            <td>{secondInstallment.date_of_maturity || "-"}</td>
                            <td>{thirdInstallment.date_of_maturity || "-"}</td>
                          </tr>
                          <tr>
                            <td>Date of renewal</td>
                            <td>{firstInstallment.date_of_renewal || "-"}</td>
                            <td>{secondInstallment.date_of_renewal || "-"}</td>
                            <td>{thirdInstallment.date_of_renewal || "-"}</td>
                          </tr>
                        </tbody>
                      </Table></>)}

                    {/* For Degree Colleges / programmes sanctioned after 2021-22 - Using ugCorpusFunds data */}
                    {ugCorpusFunds.length > 0 && (<>
                      <h5 className="text-success mb-3">For Degree Colleges / programmes sanctioned after 2021-22</h5>
                      <Table bordered responsive>
                        <thead className="table-primary text-center">
                          <tr>
                            <th>Sl. No.</th>
                            <th>Programme</th>
                            <th>Amount</th>
                            <th>Period (from - to)</th>
                            <th>FDR / Bank Guarantee No.</th>
                            <th>Date</th>
                            <th>Name & address of the Issuing Bank (with IFSC code)</th>
                            <th>Date of maturity</th>
                            <th>Date of renewal</th>
                          </tr>
                        </thead>
                        <tbody>
                          {ugCorpusFunds?.map((item, index) => (
                            <tr key={item.sno || index}>
                              <td className="text-center">{index + 1}</td>
                              <td>{item?.course_name || "-"}</td>
                              <td>{item?.amount || "-"}</td>
                              <td>{item?.period_from && item.period_to ? `${item.period_from} - ${item.period_to}` : "-"}</td>
                              <td>{item?.fdr_bank_number || "-"}</td>
                              <td>{item?.corpus_date || "-"}</td>
                              <td>{item?.bank_address && item.ifsc ? `${item.bank_address} (${item.ifsc})` : item.bank_address || item.ifsc || "-"}</td>
                              <td>{item?.date_maturity || "-"}</td>
                              <td>{item?.date_renewal || "-"}</td>
                            </tr>
                          ))}
                        </tbody>
                      </Table>
                    </>)}

                    {/* For existing PG Programmes sanctioned before 2021-22 */}
                    {getPGBEFORE.length > 0 && (
                      <>
                        <h5 className="text-success mb-3">For existing PG Programmes sanctioned before 2021-22</h5>
                        <Table bordered responsive>
                          <thead className="table-primary text-center">
                            <tr>
                              <th>Sl. No.</th>
                              <th>Programme</th>
                              <th>Amount</th>
                              <th>Period (from - to)</th>
                              <th>FDR / Bank Guarantee No.</th>
                              <th>Date</th>
                              <th>Name & address of the Issuing Bank (with IFSC code)</th>
                              <th>Date of maturity</th>
                              <th>Date of renewal</th>
                            </tr>
                          </thead>
                          <tbody>
                            {getPGBEFORE?.map((item, index) => (
                              <tr key={index}>
                                <td className="text-center">{index + 1}</td>

                                <td>{item.course_name || "-"}</td>
                                <td>{item.amount || "-"}</td>

                                <td>{item.period_from && item.period_to ? `${item.period_from} - ${item.period_to}` : "-"}</td>

                                <td>{item.fdr_bank_number || "-"}</td>
                                <td>{item.corpus_date || "-"}</td>

                                <td>{item.bank_address ? `${item.bank_address} (${item.ifsc || "-"})` : "-"}</td>

                                <td>{item.date_maturity || "-"}</td>
                                <td>{item.date_renewal || "-"}</td>
                              </tr>
                            ))}
                          </tbody>
                        </Table>
                      </>
                    )}

                    {/* For existing PG Programmes sanctioned after 2021-22 - Using pgCorpusFunds data */}
                    {pgCorpusFunds.length > 0 && (
                      <>
                        <h5 className="text-success mb-3">For existing PG Programmes sanctioned after 2021-22</h5>
                        <Table bordered responsive>
                          <thead className="table-primary text-center">
                            <tr>
                              <th>Sl. No.</th>
                              <th>Programme</th>
                              <th>Amount</th>
                              <th>Period (from - to)</th>
                              <th>FDR / Bank Guarantee No.</th>
                              <th>Date</th>
                              <th>Name & address of the Issuing Bank (with IFSC code)</th>
                              <th>Date of maturity</th>
                              <th>Date of renewal</th>
                            </tr>
                          </thead>
                          <tbody>
                            {pgCorpusFunds?.map((item, index) => (
                              <tr key={item.sno || index}>
                                <td className="text-center">{index + 1}</td>
                                <td>{item.course_name || "-"}</td>
                                <td>{item.amount || "-"}</td>
                                <td>{item.period_from && item.period_to ? `${item.period_from} - ${item.period_to}` : "-"}</td>
                                <td>{item.fdr_bank_number || "-"}</td>
                                <td>{item.corpus_date || "-"}</td>
                                <td>{item.bank_address && item.ifsc ? `${item.bank_address} (${item.ifsc})` : item.bank_address || item.ifsc || "-"}</td>
                                <td>{item.date_maturity || "-"}</td>
                                <td>{item.date_renewal || "-"}</td>
                              </tr>
                            ))}
                          </tbody>
                        </Table>
                      </>
                    )}
                  </>
                )}

                {/* Infrastructure & Academic Facilities Survey */}
                <h4 className="text-success mb-3">15.Infrastructure & Academic Facilities Survey</h4>
                <Table bordered responsive>
                  <thead className="table-primary text-center">
                    <tr>
                      <th style={{ width: "40%" }}>Particulars</th>
                      <th style={{ width: "30%" }}>Details</th>
                      <th style={{ width: "30%" }}>Remarks</th>
                    </tr>
                  </thead>
                  <tbody>
                    {/* 17. LAB */}
                    <tr className="table-secondary">
                      <td colSpan="3">
                        <strong>Lab Equipment</strong>
                      </td>
                    </tr>

                    {/* a */}
                    <tr>
                      <td>a. Whether lab equipment provided for all the subjects</td>
                      <td>
                        <input type="radio" name="infraLabEquipment" value="Yes" checked={formik.values.infraLabEquipment === "Yes"} onChange={(e) => {
                          formik.handleChange(e);
                          clearDependentFields("infraLabEquipment", e.target.value);
                        }} disabled={isDisabled} /> Yes
                        <input type="radio" name="infraLabEquipment" value="No" className="ms-2" checked={formik.values.infraLabEquipment === "No"} onChange={(e) => {
                          formik.handleChange(e);
                          clearDependentFields("infraLabEquipment", e.target.value);
                        }} disabled={isDisabled} /> No
                        <ErrorMessage name="infraLabEquipment" component="div" className="text-danger" />
                      </td>
                      <td>
                        <Field
                          as="textarea"
                          name="infraLabEquipmentRemarks"
                          className="form-control"
                          placeholder="Remarks"
                          rows="3"
                          disabled={isDisabled}
                        />
                        {/* <ErrorMessage name="infraLabEquipmentRemarks" component="div" className="text-danger" /> */}
                      </td>
                    </tr>
                    {formik.values.infraLabEquipment === "No" && (
                      <tr>
                        <td>b. Mention the subjects that lack equipment</td>
                        <td>
                          <input
                            type="text"
                            name="infraLabLackEquipment"
                            placeholder="Subjects lacking equipment"
                            className="form-control form-control-sm"
                            value={formik.values.infraLabLackEquipment}
                            onChange={formik.handleChange}
                            onBlur={formik.handleBlur}
                            disabled={isDisabled}
                          />
                          <ErrorMessage
                            name="infraLabLackEquipment"
                            component="div"
                            className="text-danger"
                          />
                        </td>
                        <td>
                          <Field
                            as="textarea"
                            name="infraLabLackEquipmentRemarks"
                            className="form-control"
                            placeholder="Remarks"
                            rows="3"
                            disabled={isDisabled}
                          />
                          {/* <ErrorMessage name="infraLabLackEquipmentRemarks" component="div" className="text-danger" /> */}
                        </td>
                      </tr>
                    )}

                    {/* 18. LIBRARY */}
                    <tr className="table-secondary">
                      <td colSpan="3">
                        <strong>Library</strong>
                      </td>
                    </tr>

                    {/* a */}
                    <tr>
                      <td>a. Whether library books are provided for all the subjects</td>
                      <td>
                        <input type="radio" name="infraLibraryBooksProvided" value="Yes" checked={formik.values.infraLibraryBooksProvided === "Yes"} onChange={(e) => {
                          formik.handleChange(e);
                          clearDependentFields("infraLibraryBooksProvided", e.target.value);
                        }} disabled={isDisabled} /> Yes
                        <input type="radio" name="infraLibraryBooksProvided" value="No" className="ms-2" checked={formik.values.infraLibraryBooksProvided === "No"} onChange={(e) => {
                          formik.handleChange(e);
                          clearDependentFields("infraLibraryBooksProvided", e.target.value);
                        }} disabled={isDisabled} /> No
                        <ErrorMessage name="infraLibraryBooksProvided" component="div" className="text-danger" />
                      </td>
                      <td>
                        <Field
                          as="textarea"
                          name="infraLibraryBooksProvidedRemarks"
                          className="form-control"
                          placeholder="Remarks"
                          rows="3"
                          disabled={isDisabled}
                        />
                        {/* <ErrorMessage name="infraLibraryBooksProvidedRemarks" component="div" className="text-danger" /> */}
                      </td>
                    </tr>
                    {formik.values.infraLibraryBooksProvided === "No" && (
                      <tr>
                        <td>b. Mention the subjects that lack books</td>
                        <td>
                          <input
                            type="text"
                            name="infraLibraryLackBooks"
                            placeholder="Subjects lacking books"
                            value={formik.values.infraLibraryLackBooks}
                            onChange={formik.handleChange}
                            onBlur={formik.handleBlur}
                            className="form-control form-control-sm"
                            disabled={isDisabled}
                          />
                          <ErrorMessage
                            name="infraLibraryLackBooks"
                            component="div"
                            className="text-danger"
                          />
                        </td>
                        <td>
                          <Field
                            as="textarea"
                            name="infraLibraryLackBooksRemarks"
                            className="form-control"
                            placeholder="Remarks"
                            rows="3"
                            disabled={isDisabled}
                          />
                          {/* <ErrorMessage name="infraLibraryLackBooksRemarks" component="div" className="text-danger" /> */}
                        </td>
                      </tr>
                    )}

                    {/* 19. STAFF */}
                    <tr className="table-secondary">
                      <td colSpan="3">
                        <strong>Staff Particulars</strong>
                      </td>
                    </tr>

                    {/* a */}
                    <tr>
                      <td>a. Whether adequate teaching and supporting staff are provided to run the colleges as per the University / UGC norms</td>
                      <td>
                        <input type="radio" name="infraStaffRunClg" value="Yes" checked={formik.values.infraStaffRunClg === "Yes"} onChange={(e) => {
                          formik.handleChange(e);
                          clearDependentFields("infraStaffRunClg", e.target.value);
                        }} disabled={isDisabled} /> Yes
                        <input type="radio" name="infraStaffRunClg" value="No" className="ms-2" checked={formik.values.infraStaffRunClg === "No"} onChange={(e) => {
                          formik.handleChange(e);
                          clearDependentFields("infraStaffRunClg", e.target.value);
                        }} disabled={isDisabled} /> No
                        <ErrorMessage name="infraStaffRunClg" component="div" className="text-danger" />
                      </td>
                      <td>
                        <Field
                          as="textarea"
                          name="infraStaffRunClgRemarks"
                          className="form-control"
                          placeholder="Remarks"
                          rows="3"
                          disabled={isDisabled}
                        />
                        {/* <ErrorMessage name="infraStaffRunClgRemarks" component="div" className="text-danger" /> */}
                      </td>
                    </tr>
                    {formik.values.infraStaffRunClg === "No" && (
                      <tr>
                        <td>b.Mention the deficiencies</td>
                        <td>
                          <input
                            type="text"
                            name="infraStaffDeficiencies"
                            placeholder="Deficiencies"
                            value={formik.values.infraStaffDeficiencies}
                            onChange={formik.handleChange}
                            onBlur={formik.handleBlur}
                            className="form-control form-control-sm"
                            disabled={isDisabled}
                          />
                          <ErrorMessage
                            name="infraStaffDeficiencies"
                            component="div"
                            className="text-danger"
                          />
                        </td>
                        <td>
                          <Field
                            as="textarea"
                            name="infraStaffDeficienciesRemarks"
                            className="form-control"
                            placeholder="Remarks"
                            rows="3"
                            disabled={isDisabled}
                          />
                          {/* <ErrorMessage name="infraStaffDeficienciesRemarks" component="div" className="text-danger" /> */}
                        </td>
                      </tr>
                    )}
                    <tr>
                      <td>
                        Whether scholarship details are provided as per Annexure -III of the application
                      </td>
                      <td>
                        <div>
                          <label className="me-3">
                            <input
                              type="radio"
                              name="infraStaffScholarshipDetails"
                              value="Yes"
                              checked={formik.values.infraStaffScholarshipDetails === "Yes"}
                              onChange={formik.handleChange}
                              onBlur={formik.handleBlur}
                              disabled={isDisabled}
                            />{" "}
                            Yes
                          </label>

                          <label>
                            <input
                              type="radio"
                              name="infraStaffScholarshipDetails"
                              value="No"
                              checked={formik.values.infraStaffScholarshipDetails === "No"}
                              onChange={formik.handleChange}
                              onBlur={formik.handleBlur}
                              disabled={isDisabled}
                            />{" "}
                            No
                          </label>
                        </div>

                        <ErrorMessage
                          name="infraStaffScholarshipDetails"
                          component="div"
                          className="text-danger"
                        />
                      </td>
                      <td>
                        <Field
                          as="textarea"
                          name="infraStaffScholarshipDetailsRemarks"
                          className="form-control"
                          placeholder="Remarks"
                          rows="3"
                          disabled={isDisabled}
                        />
                        {/* <ErrorMessage name="infraStaffScholarshipDetailsRemarks" component="div" className="text-danger" /> */}
                      </td>
                    </tr>
                    <tr>
                      <td>
                        Whether the college secured any University ranks in the last academic year
                      </td>
                      <td>
                        <div className="d-flex gap-3">
                          <label>
                            <input
                              type="radio"
                              name="infraStaffUniversityRanks"
                              value="Yes"
                              checked={formik.values.infraStaffUniversityRanks === "Yes"}
                              onChange={formik.handleChange}
                              onBlur={formik.handleBlur}
                              disabled={isDisabled}
                            />{" "}
                            Yes
                          </label>

                          <label>
                            <input
                              type="radio"
                              name="infraStaffUniversityRanks"
                              value="No"
                              checked={formik.values.infraStaffUniversityRanks === "No"}
                              onChange={formik.handleChange}
                              onBlur={formik.handleBlur}
                              disabled={isDisabled}
                            />{" "}
                            No
                          </label>
                        </div>

                        <ErrorMessage
                          name="infraStaffUniversityRanks"
                          component="div"
                          className="text-danger"
                        />
                      </td>
                      <td>
                        <Field
                          as="textarea"
                          name="infraStaffUniversityRanksRemarks"
                          className="form-control"
                          placeholder="Remarks"
                          rows="3"
                          disabled={isDisabled}
                        />
                        {/* <ErrorMessage name="infraStaffUniversityRanksRemarks" component="div" className="text-danger" /> */}
                      </td>
                    </tr>
                    <tr>
                      <td>
                        Whether the college conducted extension activities during the last academic year
                      </td>
                      <td>
                        <div className="d-flex gap-3">
                          <label>
                            <input
                              type="radio"
                              name="infraStaffConductedExtension"
                              value="Yes"
                              checked={formik.values.infraStaffConductedExtension === "Yes"}
                              onChange={formik.handleChange}
                              onBlur={formik.handleBlur}
                              disabled={isDisabled}
                            />{" "}
                            Yes
                          </label>

                          <label>
                            <input
                              type="radio"
                              name="infraStaffConductedExtension"
                              value="No"
                              checked={formik.values.infraStaffConductedExtension === "No"}
                              onChange={formik.handleChange}
                              onBlur={formik.handleBlur}
                              disabled={isDisabled}
                            />{" "}
                            No
                          </label>
                        </div>

                        <ErrorMessage
                          name="infraStaffConductedExtension"
                          component="div"
                          className="text-danger"
                        />
                      </td>
                      <td>
                        <Field
                          as="textarea"
                          name="infraStaffConductedExtensionRemarks"
                          className="form-control"
                          placeholder="Remarks"
                          rows="3"
                          disabled={isDisabled}
                        />
                        {/* <ErrorMessage name="infraStaffConductedExtensionRemarks" component="div" className="text-danger" /> */}
                      </td>
                    </tr>
                    <tr>
                      <td>Whether the college has functional website</td>
                      <td>
                        <input type="radio" name="infraStaffFunctionalWebsite" value="Yes" disabled={isDisabled} checked={formik.values.infraStaffFunctionalWebsite === "Yes"} onChange={() =>
                          formik.setFieldValue("infraStaffFunctionalWebsite", "Yes")
                        } /> Yes
                        <input type="radio" name="infraStaffFunctionalWebsite" value="No" className="ms-2" disabled={isDisabled} checked={formik.values.infraStaffFunctionalWebsite === "No"} onChange={() =>
                          formik.setFieldValue("infraStaffFunctionalWebsite", "No")
                        } /> No
                        <ErrorMessage name="infraStaffFunctionalWebsite" component="div" className="text-danger" />
                      </td>
                      <td>
                        <Field
                          as="textarea"
                          name="infraStaffFunctionalWebsiteRemarks"
                          className="form-control"
                          placeholder="Remarks"
                          rows="3"
                          disabled={isDisabled}
                        />
                        {/* <ErrorMessage name="infraStaffFunctionalWebsiteRemarks" component="div" className="text-danger" /> */}
                      </td>
                    </tr>
                  </tbody>
                </Table>

                <h5 className="mb-3">Final Remarks</h5>
                <textarea
                  name="finalRemarks"
                  className="form-control"
                  rows="4"
                  placeholder="Enter final remarks..."
                  value={formik.values.finalRemarks}
                  onChange={formik.handleChange}
                  onBlur={formik.handleBlur}
                  disabled={isDisabled}
                  style={{
                    height: "auto",
                    resize: "vertical"
                  }}

                />
                {formik.touched.finalRemarks && formik.errors.finalRemarks && (
                  <div className="text-danger">{formik.errors.finalRemarks}</div>
                )}

                <div className="mb-3">
                  <h5>Final Status</h5>

                  <select name="finalStatus" className="form-select form-select-m w-auto select-input" value={formik.values.finalStatus} onChange={(e) => { formik.handleChange(e); clearDependentFields("finalStatus", e.target.value); }} onBlur={formik.handleBlur} disabled={isDisabled} >
                    <option value="">-- Select --</option>

                    <option value="DeficiencyIdentified">Deficiencies Identified</option>
                    <option value="NoDeficienciesIdentified">No Deficiencies Identified </option>
                  </select>
                  {formik.touched.finalStatus && formik.errors.finalStatus && <div className="text-danger">{formik.errors.finalStatus}</div>}
                </div>
                {formik.values.finalStatus === "DeficiencyIdentified" && (
                  <div className="mt-3">
                    <Table bordered responsive>
                      <thead className="table-primary text-center">
                        <tr>
                          <th style={{ width: "10%" }}>S.No</th>
                          <th style={{ width: "70%" }}>Deficiency Identified</th>
                          <th style={{ width: "20%" }}>Action</th>
                        </tr>
                      </thead>
                      <FieldArray name="deficiencies">
                        {({ push, remove, form }) => {
                          const deficiencies = formik.values.deficiencies;
                          return (
                            <tbody>
                              {deficiencies && deficiencies.map((item, index) => (
                                <tr key={index}>
                                  <td className="text-center fw-bold">{index + 1}</td>
                                  <td>
                                    <Field
                                      as="textarea"
                                      name={`deficiencies.${index}.remarks`}
                                      className="form-control form-control-sm"
                                      placeholder="Enter deficiency details..."
                                      rows="3"
                                      disabled={isDisabled}
                                    />
                                    <ErrorMessage
                                      name={`deficiencies.${index}.remarks`}
                                      component="small"
                                      className="text-danger"
                                    />
                                  </td>
                                  <td className="text-center">
                                    {deficiencies.length > 1 && (
                                      <button
                                        type="button"
                                        className="btn btn-link text-danger p-0"
                                        onClick={() => remove(index)}
                                        disabled={isDisabled}
                                      >
                                        <BiTrash size={20} />
                                      </button>
                                    )}
                                    {index === deficiencies.length - 1 && (
                                      <button
                                        type="button"
                                        className="btn btn-link text-success p-0 ms-2"
                                        onClick={() => push({ remarks: "" })}
                                        disabled={isDisabled}
                                      >
                                        <VscDiffAdded size={20} />Add
                                      </button>
                                    )}
                                  </td>
                                </tr>
                              ))}
                            </tbody>
                          );
                        }}
                      </FieldArray>
                    </Table>
                  </div>
                )}
              </Col>
            </Row>
          </Col>
        </Row>
        {isDisabled ? (
          <div className="d-flex justify-content-end mt-3 align-items-center">
            <span className="text-success me-3">✅ Already Submitted</span>
            {getDef?.length > 0 && (
              <button
                type="button"
                className="btn btn-primary"
                onClick={handleDownloadPDF}
              >
                📄 Download Deficiencies PDF
              </button>
            )}
          </div>
        ) : (
          <div className="d-flex justify-content-end mt-3">
            <button type="button" className="btn btn-secondary me-2" onClick={handleSave}>
              Save
            </button>
            <button type="submit" className="btn btn-primary" onClick={() => handleFinalSubmit("submit")}
            >
              Final Submit
            </button>
          </div>

        )}
      </Form>
    </FormikProvider>
  );
}


